//---------------------------------------------------------------------
//
// QR Code Generator for JavaScript
//
// Copyright (c) 2009 Kazuhiko Arase
//
// URL: http://www.d-project.com/
//
// Licensed under the MIT license:
//  http://www.opensource.org/licenses/mit-license.php
//
// The word 'QR Code' is registered trademark of
// DENSO WAVE INCORPORATED
//  http://www.denso-wave.com/qrcode/faqpatent-e.html
//
//---------------------------------------------------------------------

const mt_empty = 0;
const mt_data_true = 1;
const mt_probe = 2;
const mt_adjuster = 3;

export var qrcode = function() {

    var wafleeLogoSvgText = '<svg version="1.1" id="Слой_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" PLACEHOLDER\n' +
        '\t viewBox="0 0 100 120" style="enable-background:new 0 0 100 120;" xml:space="preserve">\n' +
        '<g>\n' +
        '\t<g>\n' +
        '\t\t\n' +
        '\t\t\t<linearGradient id="SVGID_1_" gradientUnits="userSpaceOnUse" x1="25.3126" y1="18.8252" x2="72.8862" y2="66.3987" gradientTransform="matrix(0.7071 -0.7071 -0.7071 -0.7071 45.4127 107.2099)">\n' +
        '\t\t\t<stop  offset="0" style="stop-color:#CC8950"/>\n' +
        '\t\t\t<stop  offset="0.9987" style="stop-color:#DCA96C"/>\n' +
        '\t\t</linearGradient>\n' +
        '\t\t<path style="fill:url(#SVGID_1_);" d="M82.819,16.718c-20.511-10.662-45.127-10.662-65.638,0\n' +
        '\t\t\tc-4.221-3.121-10.198-2.782-14.022,1.041c-4.211,4.21-4.211,11.035,0,15.245c0.207,0.207,0.425,0.395,0.644,0.582\n' +
        '\t\t\tc0.148,0.186,0.305,0.367,0.477,0.539l39.184,39.169c3.61,3.608,9.462,3.608,13.072,0L95.72,34.125\n' +
        '\t\t\tc0.172-0.172,0.33-0.353,0.477-0.539c0.219-0.187,0.437-0.375,0.644-0.582c4.211-4.21,4.211-11.035,0-15.245\n' +
        '\t\t\tC93.017,13.936,87.04,13.597,82.819,16.718z"/>\n' +
        '\t\t\n' +
        '\t\t\t<linearGradient id="SVGID_2_" gradientUnits="userSpaceOnUse" x1="30.5778" y1="24.09" x2="79.0538" y2="72.5661" gradientTransform="matrix(0.7071 -0.7071 -0.7071 -0.7071 45.4127 107.2099)">\n' +
        '\t\t\t<stop  offset="0" style="stop-color:#E4C395"/>\n' +
        '\t\t\t<stop  offset="1" style="stop-color:#F6D9B8"/>\n' +
        '\t\t</linearGradient>\n' +
        '\t\t<path style="fill:url(#SVGID_2_);" d="M95.72,25.413l-41.345,41.33c-2.416,2.415-6.333,2.415-8.749,0L4.28,25.413\n' +
        '\t\t\tc-2.547-2.546-2.433-6.777,0.338-9.077c26.253-21.782,64.511-21.782,90.764,0C98.154,18.636,98.267,22.867,95.72,25.413z"/>\n' +
        '\t\t\n' +
        '\t\t\t<linearGradient id="SVGID_3_" gradientUnits="userSpaceOnUse" x1="38.4459" y1="68.9313" x2="49.4263" y2="79.9117" gradientTransform="matrix(0.7071 -0.7071 -0.7071 -0.7071 45.4127 107.2099)">\n' +
        '\t\t\t<stop  offset="0" style="stop-color:#DCA96C"/>\n' +
        '\t\t\t<stop  offset="0.9987" style="stop-color:#DB964F"/>\n' +
        '\t\t</linearGradient>\n' +
        '\t\t<path style="fill:url(#SVGID_3_);" d="M25.12,15.755l6.362,6.359c0.223,0.223,0.365,0.506,0.425,0.795\n' +
        '\t\t\tc0.044,0.196,0.044,0.392,0,0.588c-0.06,0.289-0.202,0.572-0.425,0.795l-6.536,6.534c-0.61,0.61-1.569,0.61-2.179,0l-6.536-6.534\n' +
        '\t\t\tc-0.223-0.223-0.365-0.506-0.425-0.795c-0.044-0.196-0.044-0.392,0-0.588c0.06-0.289,0.202-0.572,0.425-0.795l4.183-4.181\n' +
        '\t\t\tC21.96,17.127,23.529,16.43,25.12,15.755z"/>\n' +
        '\t\t\n' +
        '\t\t\t<linearGradient id="SVGID_4_" gradientUnits="userSpaceOnUse" x1="57.7753" y1="68.0802" x2="62.8427" y2="73.1478" gradientTransform="matrix(0.7071 -0.7071 -0.7071 -0.7071 45.4127 107.2099)">\n' +
        '\t\t\t<stop  offset="0" style="stop-color:#DCA96C"/>\n' +
        '\t\t\t<stop  offset="0.9987" style="stop-color:#DB964F"/>\n' +
        '\t\t</linearGradient>\n' +
        '\t\t<path style="fill:url(#SVGID_4_);" d="M44.684,11.051c-0.011,0.033-0.033,0.065-0.06,0.093c-0.016,0.027-0.044,0.054-0.071,0.082\n' +
        '\t\t\tl-6.536,6.534c-0.61,0.61-1.569,0.61-2.179,0l-4.27-4.269c3.557-1.062,7.206-1.802,10.855-2.216\n' +
        '\t\t\tC43.175,11.187,43.927,11.111,44.684,11.051z"/>\n' +
        '\t\t\n' +
        '\t\t\t<linearGradient id="SVGID_5_" gradientUnits="userSpaceOnUse" x1="58.6878" y1="68.9928" x2="62.8427" y2="73.1477" gradientTransform="matrix(0.7071 -0.7071 -0.7071 -0.7071 45.4127 107.2099)">\n' +
        '\t\t\t<stop  offset="0" style="stop-color:#A36E3B"/>\n' +
        '\t\t\t<stop  offset="0.9987" style="stop-color:#9B4C22"/>\n' +
        '\t\t</linearGradient>\n' +
        '\t\t<path style="fill:url(#SVGID_5_);" d="M44.684,11.051c-0.011,0.033-0.033,0.065-0.06,0.093c-0.016,0.027-0.044,0.054-0.071,0.082\n' +
        '\t\t\tl-4.76,4.759c-1.601,0.25-3.203,0.566-4.788,0.942l-3.437-3.436c3.557-1.062,7.206-1.802,10.855-2.216\n' +
        '\t\t\tC43.175,11.187,43.927,11.111,44.684,11.051z"/>\n' +
        '\t\t\n' +
        '\t\t\t<linearGradient id="SVGID_6_" gradientUnits="userSpaceOnUse" x1="38.5882" y1="50.5875" x2="49.7369" y2="61.7362" gradientTransform="matrix(0.7071 -0.7071 -0.7071 -0.7071 45.4127 107.2099)">\n' +
        '\t\t\t<stop  offset="0" style="stop-color:#DCA96C"/>\n' +
        '\t\t\t<stop  offset="0.9987" style="stop-color:#DB964F"/>\n' +
        '\t\t</linearGradient>\n' +
        '\t\t<path style="fill:url(#SVGID_6_);" d="M44.228,37.685l-5.886,5.883c-0.781,0.781-2.047,0.781-2.828,0l-5.886-5.883\n' +
        '\t\t\tc-0.781-0.781-0.781-2.048,0-2.829l5.886-5.883c0.781-0.781,2.047-0.781,2.828,0l5.886,5.883\n' +
        '\t\t\tC45.009,35.637,45.009,36.904,44.228,37.685z"/>\n' +
        '\t\t\n' +
        '\t\t\t<linearGradient id="SVGID_7_" gradientUnits="userSpaceOnUse" x1="57.0715" y1="50.584" x2="68.2202" y2="61.7327" gradientTransform="matrix(0.7071 -0.7071 -0.7071 -0.7071 45.4127 107.2099)">\n' +
        '\t\t\t<stop  offset="0" style="stop-color:#DCA96C"/>\n' +
        '\t\t\t<stop  offset="0.9987" style="stop-color:#DB964F"/>\n' +
        '\t\t</linearGradient>\n' +
        '\t\t<path style="fill:url(#SVGID_7_);" d="M57.3,24.618l-5.886,5.883c-0.781,0.781-2.047,0.781-2.828,0L42.7,24.618\n' +
        '\t\t\tc-0.781-0.781-0.781-2.048,0-2.829l5.886-5.883c0.781-0.781,2.047-0.781,2.828,0l5.886,5.883\n' +
        '\t\t\tC58.081,22.57,58.081,23.837,57.3,24.618z"/>\n' +
        '\t\t\n' +
        '\t\t\t<linearGradient id="SVGID_8_" gradientUnits="userSpaceOnUse" x1="74.5685" y1="51.2884" x2="79.636" y2="56.356" gradientTransform="matrix(0.7071 -0.7071 -0.7071 -0.7071 45.4127 107.2099)">\n' +
        '\t\t\t<stop  offset="0" style="stop-color:#DCA96C"/>\n' +
        '\t\t\t<stop  offset="0.9987" style="stop-color:#DB964F"/>\n' +
        '\t\t</linearGradient>\n' +
        '\t\t<path style="fill:url(#SVGID_8_);" d="M68.432,13.49l-4.27,4.269c-0.61,0.61-1.569,0.61-2.179,0l-6.536-6.534\n' +
        '\t\t\tc-0.027-0.027-0.054-0.054-0.071-0.082c-0.027-0.027-0.049-0.06-0.06-0.093c0.757,0.06,1.509,0.136,2.26,0.223\n' +
        '\t\t\tC61.226,11.688,64.875,12.429,68.432,13.49z"/>\n' +
        '\t\t<path style="fill:#F3DCC1;" d="M69.608,13.403l-5.207,5.205c-0.746,0.746-1.868,0.789-2.549,0.109l-7.326-7.323\n' +
        '\t\t\tc-0.027-0.027-0.06-0.06-0.076-0.087c-0.033-0.033-0.06-0.071-0.065-0.109c0.365,0.016,0.73,0.033,1.089,0.054l6.509,6.506\n' +
        '\t\t\tc0.61,0.61,1.569,0.61,2.179,0l4.27-4.269L69.608,13.403z"/>\n' +
        '\t\t<path style="fill:#F3DCC1;" d="M30.392,13.403l5.207,5.205c0.746,0.746,1.868,0.789,2.549,0.109l7.326-7.323\n' +
        '\t\t\tc0.027-0.027,0.06-0.06,0.076-0.087c0.033-0.033,0.06-0.071,0.065-0.109c-0.365,0.016-0.73,0.033-1.089,0.054l-6.509,6.506\n' +
        '\t\t\tc-0.61,0.61-1.569,0.61-2.179,0l-4.27-4.269L30.392,13.403z"/>\n' +
        '\t\t\n' +
        '\t\t\t<linearGradient id="SVGID_9_" gradientUnits="userSpaceOnUse" x1="75.481" y1="52.201" x2="79.636" y2="56.356" gradientTransform="matrix(0.7071 -0.7071 -0.7071 -0.7071 45.4127 107.2099)">\n' +
        '\t\t\t<stop  offset="0" style="stop-color:#A36E3B"/>\n' +
        '\t\t\t<stop  offset="0.9987" style="stop-color:#9B4C22"/>\n' +
        '\t\t</linearGradient>\n' +
        '\t\t<path style="fill:url(#SVGID_9_);" d="M68.432,13.49l-3.437,3.436c-1.585-0.376-3.186-0.691-4.788-0.942l-4.76-4.759\n' +
        '\t\t\tc-0.027-0.027-0.054-0.054-0.071-0.082c-0.027-0.027-0.049-0.06-0.06-0.093c0.757,0.06,1.509,0.136,2.26,0.223\n' +
        '\t\t\tC61.226,11.688,64.875,12.429,68.432,13.49z"/>\n' +
        '\t\t\n' +
        '\t\t\t<linearGradient id="SVGID_10_" gradientUnits="userSpaceOnUse" x1="38.5918" y1="32.1042" x2="49.7404" y2="43.253" gradientTransform="matrix(0.7071 -0.7071 -0.7071 -0.7071 45.4127 107.2099)">\n' +
        '\t\t\t<stop  offset="0" style="stop-color:#DCA96C"/>\n' +
        '\t\t\t<stop  offset="0.9987" style="stop-color:#DB964F"/>\n' +
        '\t\t</linearGradient>\n' +
        '\t\t<path style="fill:url(#SVGID_10_);" d="M57.3,50.752l-5.886,5.883c-0.781,0.781-2.047,0.781-2.828,0L42.7,50.752\n' +
        '\t\t\tc-0.781-0.781-0.781-2.048,0-2.829l5.886-5.883c0.781-0.781,2.047-0.781,2.828,0l5.886,5.883\n' +
        '\t\t\tC58.081,48.704,58.081,49.971,57.3,50.752z"/>\n' +
        '\t\t\n' +
        '\t\t\t<linearGradient id="SVGID_11_" gradientUnits="userSpaceOnUse" x1="57.075" y1="32.1007" x2="68.2237" y2="43.2494" gradientTransform="matrix(0.7071 -0.7071 -0.7071 -0.7071 45.4127 107.2099)">\n' +
        '\t\t\t<stop  offset="0" style="stop-color:#DCA96C"/>\n' +
        '\t\t\t<stop  offset="0.9987" style="stop-color:#DB964F"/>\n' +
        '\t\t</linearGradient>\n' +
        '\t\t<path style="fill:url(#SVGID_11_);" d="M70.372,37.685l-5.886,5.883c-0.781,0.781-2.047,0.781-2.828,0l-5.886-5.883\n' +
        '\t\t\tc-0.781-0.781-0.781-2.048,0-2.829l5.886-5.883c0.781-0.781,2.047-0.781,2.828,0l5.886,5.883\n' +
        '\t\t\tC71.153,35.637,71.153,36.904,70.372,37.685z"/>\n' +
        '\t\t\n' +
        '\t\t\t<linearGradient id="SVGID_12_" gradientUnits="userSpaceOnUse" x1="75.4187" y1="31.9584" x2="86.3992" y2="42.9388" gradientTransform="matrix(0.7071 -0.7071 -0.7071 -0.7071 45.4127 107.2099)">\n' +
        '\t\t\t<stop  offset="0" style="stop-color:#DCA96C"/>\n' +
        '\t\t\t<stop  offset="0.9987" style="stop-color:#DB964F"/>\n' +
        '\t\t</linearGradient>\n' +
        '\t\t<path style="fill:url(#SVGID_12_);" d="M79.586,17.933l4.183,4.181c0.223,0.223,0.365,0.506,0.425,0.795\n' +
        '\t\t\tc0.044,0.196,0.044,0.392,0,0.588c-0.06,0.289-0.202,0.572-0.425,0.795l-6.536,6.534c-0.61,0.61-1.569,0.61-2.179,0l-6.536-6.534\n' +
        '\t\t\tc-0.223-0.223-0.365-0.506-0.425-0.795c-0.044-0.196-0.044-0.392,0-0.588c0.06-0.289,0.202-0.572,0.425-0.795l6.362-6.359\n' +
        '\t\t\tC76.471,16.43,78.04,17.127,79.586,17.933z"/>\n' +
        '\t\t\n' +
        '\t\t\t<linearGradient id="SVGID_13_" gradientUnits="userSpaceOnUse" x1="42.6253" y1="36.1385" x2="49.8734" y2="43.3866" gradientTransform="matrix(0.7071 -0.7071 -0.7071 -0.7071 45.4127 107.2099)">\n' +
        '\t\t\t<stop  offset="0" style="stop-color:#A36E3B"/>\n' +
        '\t\t\t<stop  offset="0.9987" style="stop-color:#9B4C22"/>\n' +
        '\t\t</linearGradient>\n' +
        '\t\t<path style="fill:url(#SVGID_13_);" d="M51.089,41.715l6.536,6.534c0.599,0.599,0.599,1.579,0,2.178l-1.089,1.089l-6.264-6.261\n' +
        '\t\t\tc-0.153-0.152-0.392-0.152-0.545,0l-6.264,6.261l-1.089-1.089c-0.599-0.599-0.599-1.579,0-2.178l6.536-6.534\n' +
        '\t\t\tC49.51,41.116,50.49,41.116,51.089,41.715z"/>\n' +
        '\t\t\n' +
        '\t\t\t<linearGradient id="SVGID_14_" gradientUnits="userSpaceOnUse" x1="42.6218" y1="54.6218" x2="49.8699" y2="61.8699" gradientTransform="matrix(0.7071 -0.7071 -0.7071 -0.7071 45.4127 107.2099)">\n' +
        '\t\t\t<stop  offset="0" style="stop-color:#A36E3B"/>\n' +
        '\t\t\t<stop  offset="0.9987" style="stop-color:#9B4C22"/>\n' +
        '\t\t</linearGradient>\n' +
        '\t\t<path style="fill:url(#SVGID_14_);" d="M38.017,28.648l6.536,6.534c0.599,0.599,0.599,1.579,0,2.178l-1.089,1.089L37.2,32.187\n' +
        '\t\t\tc-0.153-0.152-0.392-0.152-0.545,0l-6.264,6.261l-1.089-1.089c-0.599-0.599-0.599-1.579,0-2.178l6.536-6.534\n' +
        '\t\t\tC36.438,28.049,37.418,28.049,38.017,28.648z"/>\n' +
        '\t\t\n' +
        '\t\t\t<linearGradient id="SVGID_15_" gradientUnits="userSpaceOnUse" x1="42.6196" y1="73.105" x2="49.4264" y2="79.9116" gradientTransform="matrix(0.7071 -0.7071 -0.7071 -0.7071 45.4127 107.2099)">\n' +
        '\t\t\t<stop  offset="0" style="stop-color:#A36E3B"/>\n' +
        '\t\t\t<stop  offset="0.9987" style="stop-color:#9B4C22"/>\n' +
        '\t\t</linearGradient>\n' +
        '\t\t<path style="fill:url(#SVGID_15_);" d="M25.12,15.755l6.362,6.359c0.223,0.223,0.365,0.506,0.425,0.795\n' +
        '\t\t\tc0.033,0.196,0.033,0.392,0,0.588c-0.06,0.289-0.202,0.572-0.425,0.795l-1.089,1.089l-6.264-6.261\n' +
        '\t\t\tc-0.153-0.152-0.392-0.152-0.545,0l-6.264,6.261l-1.089-1.089c-0.223-0.223-0.365-0.506-0.425-0.795\n' +
        '\t\t\tc-0.033-0.196-0.033-0.392,0-0.588c0.06-0.289,0.202-0.572,0.425-0.795l4.183-4.181C21.96,17.127,23.529,16.43,25.12,15.755z"/>\n' +
        '\t\t\n' +
        '\t\t\t<linearGradient id="SVGID_16_" gradientUnits="userSpaceOnUse" x1="61.105" y1="54.6182" x2="68.3531" y2="61.8664" gradientTransform="matrix(0.7071 -0.7071 -0.7071 -0.7071 45.4127 107.2099)">\n' +
        '\t\t\t<stop  offset="0" style="stop-color:#A36E3B"/>\n' +
        '\t\t\t<stop  offset="0.9987" style="stop-color:#9B4C22"/>\n' +
        '\t\t</linearGradient>\n' +
        '\t\t<path style="fill:url(#SVGID_16_);" d="M51.089,15.581l6.536,6.534c0.599,0.599,0.599,1.579,0,2.178l-1.089,1.089l-6.264-6.261\n' +
        '\t\t\tc-0.153-0.152-0.392-0.152-0.545,0l-6.264,6.261l-1.089-1.089c-0.599-0.599-0.599-1.579,0-2.178l6.536-6.534\n' +
        '\t\t\tC49.51,14.982,50.49,14.982,51.089,15.581z"/>\n' +
        '\t\t\n' +
        '\t\t\t<linearGradient id="SVGID_17_" gradientUnits="userSpaceOnUse" x1="61.1085" y1="36.135" x2="68.3566" y2="43.3831" gradientTransform="matrix(0.7071 -0.7071 -0.7071 -0.7071 45.4127 107.2099)">\n' +
        '\t\t\t<stop  offset="0" style="stop-color:#A36E3B"/>\n' +
        '\t\t\t<stop  offset="0.9987" style="stop-color:#9B4C22"/>\n' +
        '\t\t</linearGradient>\n' +
        '\t\t<path style="fill:url(#SVGID_17_);" d="M64.161,28.648l6.536,6.534c0.599,0.599,0.599,1.579,0,2.178l-1.089,1.089l-6.264-6.261\n' +
        '\t\t\tc-0.153-0.152-0.392-0.152-0.545,0l-6.264,6.261l-1.089-1.089c-0.599-0.599-0.599-1.579,0-2.178l6.536-6.534\n' +
        '\t\t\tC62.582,28.049,63.562,28.049,64.161,28.648z"/>\n' +
        '\t\t\n' +
        '\t\t\t<linearGradient id="SVGID_18_" gradientUnits="userSpaceOnUse" x1="79.5925" y1="36.1321" x2="86.3992" y2="42.9388" gradientTransform="matrix(0.7071 -0.7071 -0.7071 -0.7071 45.4127 107.2099)">\n' +
        '\t\t\t<stop  offset="0" style="stop-color:#A36E3B"/>\n' +
        '\t\t\t<stop  offset="0.9987" style="stop-color:#9B4C22"/>\n' +
        '\t\t</linearGradient>\n' +
        '\t\t<path style="fill:url(#SVGID_18_);" d="M79.586,17.933l4.183,4.181c0.223,0.223,0.365,0.506,0.425,0.795\n' +
        '\t\t\tc0.033,0.196,0.033,0.392,0,0.588c-0.06,0.289-0.202,0.572-0.425,0.795l-1.089,1.089l-6.264-6.261\n' +
        '\t\t\tc-0.153-0.152-0.392-0.152-0.545,0l-6.264,6.261l-1.089-1.089c-0.223-0.223-0.365-0.506-0.425-0.795\n' +
        '\t\t\tc-0.033-0.196-0.033-0.392,0-0.588c0.06-0.289,0.202-0.572,0.425-0.795l6.362-6.359C76.471,16.43,78.04,17.127,79.586,17.933z"/>\n' +
        '\t\t<path style="fill:#F3DCC1;" d="M57.74,48.385c0.79,0.898,0.746,2.27-0.114,3.131l-5.991,5.989c-0.904,0.904-2.364,0.904-3.268,0\n' +
        '\t\t\tl-5.991-5.989c-0.861-0.86-0.904-2.232-0.114-3.131c-0.479,0.599-0.441,1.486,0.114,2.042l6.536,6.534\n' +
        '\t\t\tc0.599,0.599,1.58,0.599,2.179,0l6.536-6.534C58.181,49.871,58.219,48.984,57.74,48.385z"/>\n' +
        '\t\t<path style="fill:#F3DCC1;" d="M70.812,35.318c0.79,0.898,0.746,2.27-0.114,3.131l-5.991,5.989c-0.904,0.904-2.364,0.904-3.268,0\n' +
        '\t\t\tl-5.991-5.989c-0.861-0.86-0.904-2.232-0.114-3.131c-0.479,0.599-0.441,1.486,0.114,2.042l6.536,6.534\n' +
        '\t\t\tc0.599,0.599,1.58,0.599,2.179,0l6.536-6.534C71.253,36.804,71.291,35.917,70.812,35.318z"/>\n' +
        '\t\t<path style="fill:#F3DCC1;" d="M83.884,22.251c0.79,0.898,0.746,2.27-0.114,3.131l-5.991,5.989c-0.904,0.904-2.364,0.904-3.268,0\n' +
        '\t\t\tl-5.991-5.989c-0.861-0.86-0.904-2.232-0.114-3.131c-0.479,0.599-0.441,1.486,0.114,2.042l6.536,6.534\n' +
        '\t\t\tc0.599,0.599,1.58,0.599,2.179,0l6.536-6.534C84.325,23.737,84.363,22.85,83.884,22.251z"/>\n' +
        '\t\t<path style="fill:#F3DCC1;" d="M57.74,22.251c0.79,0.898,0.746,2.27-0.114,3.131l-5.991,5.989c-0.904,0.904-2.364,0.904-3.268,0\n' +
        '\t\t\tl-5.991-5.989c-0.861-0.86-0.904-2.232-0.114-3.131c-0.479,0.599-0.441,1.486,0.114,2.042l6.536,6.534\n' +
        '\t\t\tc0.599,0.599,1.58,0.599,2.179,0l6.536-6.534C58.181,23.737,58.219,22.85,57.74,22.251z"/>\n' +
        '\t\t<path style="fill:#F3DCC1;" d="M44.668,35.318c0.79,0.898,0.746,2.27-0.114,3.131l-5.991,5.989c-0.904,0.904-2.364,0.904-3.268,0\n' +
        '\t\t\tl-5.991-5.989c-0.861-0.86-0.904-2.232-0.114-3.131c-0.479,0.599-0.441,1.486,0.114,2.042l6.536,6.534\n' +
        '\t\t\tc0.599,0.599,1.58,0.599,2.179,0l6.536-6.534C45.109,36.804,45.147,35.917,44.668,35.318z"/>\n' +
        '\t\t<path style="fill:#F3DCC1;" d="M31.596,22.251c0.79,0.898,0.746,2.27-0.114,3.131L25.49,31.37c-0.904,0.904-2.364,0.904-3.268,0\n' +
        '\t\t\tl-5.991-5.989c-0.861-0.86-0.904-2.232-0.114-3.131c-0.479,0.599-0.441,1.486,0.114,2.042l6.536,6.534\n' +
        '\t\t\tc0.599,0.599,1.58,0.599,2.179,0l6.536-6.534C32.037,23.737,32.075,22.85,31.596,22.251z"/>\n' +
        '\t</g>\n' +
        '\t<g>\n' +
        '\t\t<path style="fill:#363636;" d="M21.362,103.617c1.306,0.572,1.957,1.273,1.957,2.109c0,0.348-0.164,0.903-0.49,1.666\n' +
        '\t\t\tc-0.326,0.764-0.602,1.433-0.826,2.002l-3.36,8.19c-0.306,0.898-0.816,1.527-1.53,1.895c-0.306,0.142-0.691,0.214-1.162,0.214\n' +
        '\t\t\tc-0.468,0-0.92-0.179-1.358-0.535c-0.44-0.356-0.729-0.719-0.873-1.084l-0.244-0.52c-0.164-0.408-0.764-1.997-1.803-4.768\n' +
        '\t\t\tc-0.204,0.487-0.505,1.288-0.9,2.398c-0.398,1.112-0.654,1.803-0.766,2.079c-0.112,0.276-0.182,0.458-0.214,0.55\n' +
        '\t\t\tc-0.03,0.092-0.117,0.261-0.259,0.505c-0.142,0.244-0.306,0.458-0.49,0.642c-0.487,0.49-1.05,0.734-1.681,0.734\n' +
        '\t\t\ts-1.159-0.179-1.587-0.535c-0.43-0.356-0.714-0.719-0.858-1.084l-4.614-11.247C0.102,106.216,0,105.818,0,105.634\n' +
        '\t\t\tc0-0.813,0.582-1.455,1.741-1.925c0.654-0.264,1.181-0.398,1.589-0.398s0.739,0.087,0.995,0.261\n' +
        '\t\t\tc0.254,0.174,0.433,0.346,0.535,0.52s0.184,0.351,0.244,0.535c0.346,0.816,1.069,2.731,2.171,5.745l1.803-4.952\n' +
        '\t\t\tc0.122-0.405,0.346-0.764,0.672-1.069c0.589-0.589,1.191-0.885,1.803-0.885s1.137,0.164,1.574,0.49\n' +
        '\t\t\tc0.438,0.326,0.739,0.652,0.9,0.977l0.246,0.52c1.017,2.853,1.619,4.482,1.803,4.89l1.863-5.074\n' +
        '\t\t\tc0.49-1.303,1.224-1.957,2.201-1.957C20.527,103.311,20.935,103.415,21.362,103.617z"/>\n' +
        '\t\t<path style="fill:#363636;" d="M35.452,105.206c0.122-1.139,0.928-1.711,2.415-1.711c0.796,0,1.385,0.062,1.773,0.184\n' +
        '\t\t\tc0.386,0.122,0.657,0.336,0.808,0.642c0.154,0.306,0.246,0.577,0.276,0.811c0.03,0.234,0.045,0.584,0.045,1.055v10.695\n' +
        '\t\t\tc0,0.47-0.015,0.821-0.045,1.055c-0.03,0.236-0.117,0.505-0.261,0.811c-0.284,0.53-0.982,0.793-2.092,0.793\n' +
        '\t\t\tc-1.112,0-1.855-0.137-2.231-0.41c-0.378-0.276-0.597-0.679-0.657-1.209c-0.756,1.079-2.015,1.619-3.776,1.619\n' +
        '\t\t\tc-1.763,0-3.398-0.803-4.905-2.413c-1.51-1.609-2.263-3.48-2.263-5.609s0.761-3.994,2.278-5.594\n' +
        '\t\t\tc1.517-1.599,3.184-2.398,4.997-2.398c0.691,0,1.323,0.122,1.895,0.366c0.57,0.244,0.968,0.473,1.191,0.686\n' +
        '\t\t\tS35.311,105.005,35.452,105.206z M29.891,111.563c0,0.674,0.264,1.278,0.793,1.818c0.53,0.542,1.171,0.811,1.925,0.811\n' +
        '\t\t\ts1.38-0.276,1.88-0.826c0.5-0.55,0.749-1.157,0.749-1.818c0-0.662-0.239-1.278-0.719-1.848c-0.478-0.572-1.119-0.856-1.925-0.856\n' +
        '\t\t\tc-0.803,0-1.455,0.284-1.955,0.856C30.14,110.27,29.891,110.892,29.891,111.563z"/>\n' +
        '\t\t<path style="fill:#363636;" d="M52.629,103.527c1.405,0,2.231,0.386,2.475,1.159c0.122,0.388,0.184,0.898,0.184,1.53\n' +
        '\t\t\ts-0.067,1.137-0.199,1.512c-0.132,0.378-0.341,0.647-0.627,0.811c-0.428,0.244-1.05,0.366-1.863,0.366l-1.957-0.122v8.19\n' +
        '\t\t\tc0,0.776-0.097,1.351-0.289,1.729c-0.194,0.376-0.49,0.624-0.888,0.749c-0.398,0.122-0.913,0.182-1.542,0.182\n' +
        '\t\t\tc-0.632,0-1.137-0.065-1.515-0.199c-0.376-0.132-0.647-0.346-0.808-0.642c-0.164-0.293-0.261-0.565-0.291-0.808\n' +
        '\t\t\tc-0.03-0.246-0.045-0.602-0.045-1.069v-8.101h-1.102c-0.53-0.04-0.905-0.162-1.129-0.366c-0.388-0.388-0.582-1.132-0.582-2.231\n' +
        '\t\t\tc0-1.671,0.602-2.507,1.803-2.507h1.01v-1.619c0-1.569,0.56-2.99,1.679-4.263c1.122-1.273,2.741-1.91,4.86-1.91\n' +
        '\t\t\tc0.47,0,0.821,0.015,1.055,0.045c0.234,0.032,0.505,0.127,0.811,0.291c0.55,0.266,0.826,1.05,0.826,2.353\n' +
        '\t\t\tc0,0.977-0.174,1.681-0.52,2.109c-0.286,0.326-0.734,0.51-1.346,0.55c-0.184,0-0.47,0-0.856,0c-0.754,0-1.132,0.256-1.132,0.764\n' +
        '\t\t\tv1.681L52.629,103.527z"/>\n' +
        '\t\t<path style="fill:#363636;" d="M56.969,98.605c0-0.468,0.015-0.821,0.045-1.055s0.117-0.505,0.261-0.808\n' +
        '\t\t\tc0.284-0.552,1.079-0.826,2.383-0.826c1.244,0,2.017,0.274,2.323,0.826c0.162,0.303,0.259,0.58,0.291,0.823\n' +
        '\t\t\tc0.03,0.246,0.045,0.602,0.045,1.069v14.152c0,0.734,0.062,1.196,0.184,1.39c0.122,0.194,0.393,0.291,0.811,0.291\n' +
        '\t\t\tc0.415,0,0.696,0.015,0.838,0.045c0.144,0.03,0.316,0.117,0.52,0.259c0.408,0.266,0.612,0.99,0.612,2.171\n' +
        '\t\t\tc0,1.283-0.204,2.067-0.612,2.353c-0.53,0.368-1.793,0.428-3.788,0.184c-1.569-0.204-2.589-0.724-3.057-1.559\n' +
        '\t\t\tc-0.572-0.997-0.856-2.587-0.856-4.768C56.969,113.152,56.969,98.605,56.969,98.605z"/>\n' +
        '\t\t<path style="fill:#363636;" d="M82.488,109.623c0,1.254-0.311,2.181-0.933,2.781c-0.622,0.602-1.308,0.903-2.062,0.903H72.25\n' +
        '\t\t\tc0,0.57,0.336,1.05,1.007,1.435c0.672,0.388,1.346,0.582,2.017,0.582c1.181,0,2.109-0.122,2.781-0.368l0.336-0.122\n' +
        '\t\t\tc0.49-0.224,0.898-0.336,1.224-0.336c0.652,0,1.211,0.458,1.681,1.375c0.264,0.55,0.398,1.02,0.398,1.405\n' +
        '\t\t\tc0,1.813-2.171,2.721-6.511,2.721c-1.507,0-2.848-0.261-4.019-0.781c-1.171-0.517-2.082-1.206-2.733-2.062\n' +
        '\t\t\tc-1.286-1.651-1.928-3.495-1.928-5.532c0-2.567,0.831-4.621,2.492-6.158c1.661-1.54,3.733-2.308,6.22-2.308\n' +
        '\t\t\tc2.83,0,4.91,1,6.233,2.995C82.142,107.213,82.488,108.37,82.488,109.623z M76.038,110.524c0.776,0,1.162-0.323,1.162-0.977\n' +
        '\t\t\tc0-0.468-0.179-0.846-0.535-1.129c-0.356-0.286-0.866-0.428-1.527-0.428s-1.321,0.269-1.972,0.808s-0.977,1.117-0.977,1.726\n' +
        '\t\t\tH76.038z"/>\n' +
        '\t\t<path style="fill:#363636;" d="M100,109.623c0,1.254-0.311,2.181-0.933,2.781c-0.622,0.602-1.308,0.903-2.062,0.903h-7.243\n' +
        '\t\t\tc0,0.57,0.336,1.05,1.007,1.435c0.672,0.388,1.346,0.582,2.017,0.582c1.181,0,2.109-0.122,2.781-0.368l0.336-0.122\n' +
        '\t\t\tc0.49-0.224,0.898-0.336,1.224-0.336c0.652,0,1.211,0.458,1.681,1.375c0.264,0.55,0.398,1.02,0.398,1.405\n' +
        '\t\t\tc0,1.813-2.171,2.721-6.511,2.721c-1.507,0-2.848-0.261-4.019-0.781c-1.171-0.517-2.082-1.206-2.733-2.062\n' +
        '\t\t\tc-1.286-1.651-1.928-3.495-1.928-5.532c0-2.567,0.831-4.621,2.492-6.158c1.661-1.54,3.733-2.308,6.22-2.308\n' +
        '\t\t\tc2.83,0,4.91,1,6.233,2.995C99.654,107.213,100,108.37,100,109.623z M93.551,110.524c0.776,0,1.162-0.323,1.162-0.977\n' +
        '\t\t\tc0-0.468-0.179-0.846-0.535-1.129c-0.356-0.286-0.866-0.428-1.527-0.428c-0.662,0-1.321,0.269-1.972,0.808\n' +
        '\t\t\ts-0.977,1.117-0.977,1.726H93.551z"/>\n' +
        '\t</g>\n' +
        '</g>\n' +
        '</svg>\n'

    //---------------------------------------------------------------------
    // qrcode
    //---------------------------------------------------------------------
  
    /**
     * qrcode
     * @param typeNumber 1 to 40
     * @param errorCorrectionLevel 'L','M','Q','H'
     */
    var qrcode = function(typeNumber, errorCorrectionLevel) {
  
      var PAD0 = 0xEC;
      var PAD1 = 0x11;
  
      var _typeNumber = typeNumber;
      var _errorCorrectionLevel = QRErrorCorrectionLevel[errorCorrectionLevel];
      var _modules = null;
      var _moduleCount = 0;
      var _dataCache = null;
      var _dataList = [];
  
      var _this = {};
  
      var makeImpl = function(test, maskPattern) {
  
        _moduleCount = _typeNumber * 4 + 17;
        _modules = function(moduleCount) {
          var modules = new Array(moduleCount);
          for (var row = 0; row < moduleCount; row += 1) {
            modules[row] = new Array(moduleCount);
            for (var col = 0; col < moduleCount; col += 1) {
              modules[row][col] = null;
            }
          }
          return modules;
        }(_moduleCount);
  
        setupPositionProbePattern(0, 0);
        setupPositionProbePattern(_moduleCount - 7, 0);
        setupPositionProbePattern(0, _moduleCount - 7);
        setupPositionAdjustPattern();
        setupTimingPattern();
        setupTypeInfo(test, maskPattern);
  
        if (_typeNumber >= 7) {
          setupTypeNumber(test);
        }
  
        if (_dataCache == null) {
          _dataCache = createData(_typeNumber, _errorCorrectionLevel, _dataList);
        }
  
        mapData(_dataCache, maskPattern);
      };
  
      var setupPositionProbePattern = function(row, col) {
  
        for (var r = -1; r <= 7; r += 1) {
  
          if (row + r <= -1 || _moduleCount <= row + r) continue;
  
          for (var c = -1; c <= 7; c += 1) {
  
            if (col + c <= -1 || _moduleCount <= col + c) continue;
  
            if ( (0 <= r && r <= 6 && (c === 0 || c === 6) )
                || (0 <= c && c <= 6 && (r === 0 || r === 6) )
                || (2 <= r && r <= 4 && 2 <= c && c <= 4) ) {
              _modules[row + r][col + c] = mt_probe;
            } else {
              _modules[row + r][col + c] = mt_empty;
            }
          }
        }
      };
  
      var getBestMaskPattern = function() {
  
        var minLostPoint = 0;
        var pattern = 0;
  
        for (var i = 0; i < 8; i += 1) {
  
          makeImpl(true, i);
  
          var lostPoint = QRUtil.getLostPoint(_this);
  
          if (i === 0 || minLostPoint > lostPoint) {
            minLostPoint = lostPoint;
            pattern = i;
          }
        }
  
        return pattern;
      };
  
      var setupTimingPattern = function() {
  
        for (var r = 8; r < _moduleCount - 8; r += 1) {
          if (_modules[r][6] !== null) {
            continue;
          }
          _modules[r][6] = (r % 2 === 0 ? mt_data_true : mt_empty);
        }
  
        for (var c = 8; c < _moduleCount - 8; c += 1) {
          if (_modules[6][c] !== null) {
            continue;
          }
          _modules[6][c] = (c % 2 === 0 ? mt_data_true : mt_empty);
        }
      };
  
      var setupPositionAdjustPattern = function() {
  
        var pos = QRUtil.getPatternPosition(_typeNumber);
  
        for (var i = 0; i < pos.length; i += 1) {
  
          for (var j = 0; j < pos.length; j += 1) {
  
            var row = pos[i];
            var col = pos[j];
  
            if (_modules[row][col] !== null) {
              continue;
            }
  
            for (var r = -2; r <= 2; r += 1) {
  
              for (var c = -2; c <= 2; c += 1) {
  
                if (r === -2 || r === 2 || c === -2 || c === 2
                    || (r === 0 && c === 0) ) {
                  _modules[row + r][col + c] = mt_adjuster;
                } else {
                  _modules[row + r][col + c] = mt_empty;
                }
              }
            }
          }
        }
      };
  
      var setupTypeNumber = function(test) {
  
        var bits = QRUtil.getBCHTypeNumber(_typeNumber);
  
        for (var i = 0; i < 18; i += 1) {
          var mod = (!test && ( (bits >> i) & 1) === 1);
          _modules[Math.floor(i / 3)][i % 3 + _moduleCount - 8 - 3] = mod ? mt_data_true : mt_empty;
        }
  
        for (var i2 = 0; i2 < 18; i2 += 1) {
          var mod2 = (!test && ( (bits >> i2) & 1) === 1);
          _modules[i2 % 3 + _moduleCount - 8 - 3][Math.floor(i / 3)] = mod2 ? mt_data_true : mt_empty;
        }
      };
  
      var setupTypeInfo = function(test, maskPattern) {
  
        var data = (_errorCorrectionLevel << 3) | maskPattern;
        var bits = QRUtil.getBCHTypeInfo(data);
  
        // vertical
        for (var i = 0; i < 15; i += 1) {
  
          var mod = (!test && ( (bits >> i) & 1) === 1);
  
          if (i < 6) {
            _modules[i][8] = mod ? mt_data_true : mt_empty;
          } else if (i < 8) {
            _modules[i + 1][8] = mod ? mt_data_true : mt_empty;
          } else {
            _modules[_moduleCount - 15 + i][8] = mod ? mt_data_true : mt_empty;
          }
        }
  
        // horizontal
        for (var i2 = 0; i2 < 15; i2 += 1) {
  
          var mod2 = (!test && ( (bits >> i2) & 1) === 1);
  
          if (i2 < 8) {
            _modules[8][_moduleCount - i2 - 1] = mod2 ? mt_data_true : mt_empty;
          } else if (i2 < 9) {
            _modules[8][15 - i2 - 1 + 1] = mod2 ? mt_data_true : mt_empty;
          } else {
            _modules[8][15 - i2 - 1] = mod2 ? mt_data_true : mt_empty;
          }
        }
  
        // fixed module
        _modules[_moduleCount - 8][8] = (!test) ? mt_data_true : mt_empty;
      };
  
      var mapData = function(data, maskPattern) {
  
        var inc = -1;
        var row = _moduleCount - 1;
        var bitIndex = 7;
        var byteIndex = 0;
        var maskFunc = QRUtil.getMaskFunction(maskPattern);
  
        for (var col = _moduleCount - 1; col > 0; col -= 2) {
  
          if (col === 6) col -= 1;
  
          while (true) {
  
            for (var c = 0; c < 2; c += 1) {
  
              if (_modules[row][col - c] === null) {
  
                var dark = false;
  
                if (byteIndex < data.length) {
                  dark = ( ( (data[byteIndex] >>> bitIndex) & 1) === 1);
                }
  
                var mask = maskFunc(row, col - c);
  
                if (mask) {
                  dark = !dark;
                }
  
                _modules[row][col - c] = dark ? mt_data_true : mt_empty;
                bitIndex -= 1;
  
                if (bitIndex === -1) {
                  byteIndex += 1;
                  bitIndex = 7;
                }
              }
            }
  
            row += inc;
  
            if (row < 0 || _moduleCount <= row) {
              row -= inc;
              inc = -inc;
              break;
            }
          }
        }
      };
  
      var createBytes = function(buffer, rsBlocks) {
  
        var offset = 0;
  
        var maxDcCount = 0;
        var maxEcCount = 0;
  
        var dcdata = new Array(rsBlocks.length);
        var ecdata = new Array(rsBlocks.length);
  
        for (var r = 0; r < rsBlocks.length; r += 1) {
  
          var dcCount = rsBlocks[r].dataCount;
          var ecCount = rsBlocks[r].totalCount - dcCount;
  
          maxDcCount = Math.max(maxDcCount, dcCount);
          maxEcCount = Math.max(maxEcCount, ecCount);
  
          dcdata[r] = new Array(dcCount);
  
          for (var i = 0; i < dcdata[r].length; i += 1) {
            dcdata[r][i] = 0xff & buffer.getBuffer()[i + offset];
          }
          offset += dcCount;
  
          var rsPoly = QRUtil.getErrorCorrectPolynomial(ecCount);
          var rawPoly = qrPolynomial(dcdata[r], rsPoly.getLength() - 1);
  
          var modPoly = rawPoly.mod(rsPoly);
          ecdata[r] = new Array(rsPoly.getLength() - 1);
          for (var i2 = 0; i2 < ecdata[r].length; i2 += 1) {
            var modIndex = i2 + modPoly.getLength() - ecdata[r].length;
            ecdata[r][i2] = (modIndex >= 0)? modPoly.getAt(modIndex) : 0;
          }
        }
  
        var totalCodeCount = 0;
        for (var i3 = 0; i3 < rsBlocks.length; i3 += 1) {
          totalCodeCount += rsBlocks[i3].totalCount;
        }
  
        var data = new Array(totalCodeCount);
        var index = 0;
  
        for (var i4 = 0; i4 < maxDcCount; i4 += 1) {
          for (var r2 = 0; r2 < rsBlocks.length; r2 += 1) {
            if (i4 < dcdata[r2].length) {
              data[index] = dcdata[r2][i4];
              index += 1;
            }
          }
        }
  
        for (var i5 = 0; i5 < maxEcCount; i5 += 1) {
          for (var r3 = 0; r3 < rsBlocks.length; r3 += 1) {
            if (i5 < ecdata[r3].length) {
              data[index] = ecdata[r3][i5];
              index += 1;
            }
          }
        }
  
        return data;
      };
  
      var createData = function(typeNumber, errorCorrectionLevel, dataList) {
  
        var rsBlocks = QRRSBlock.getRSBlocks(typeNumber, errorCorrectionLevel);
  
        var buffer = qrBitBuffer();
  
        for (var i = 0; i < dataList.length; i += 1) {
          var data = dataList[i];
          buffer.put(data.getMode(), 4);
          buffer.put(data.getLength(), QRUtil.getLengthInBits(data.getMode(), typeNumber) );
          data.write(buffer);
        }
  
        // calc num max data.
        var totalDataCount = 0;
        for (var i2 = 0; i2 < rsBlocks.length; i2 += 1) {
          totalDataCount += rsBlocks[i2].dataCount;
        }
  
        if (buffer.getLengthInBits() > totalDataCount * 8) {
          throw new Error('code length overflow. ('
            + buffer.getLengthInBits()
            + '>'
            + totalDataCount * 8
            + ')');
        }
  
        // end code
        if (buffer.getLengthInBits() + 4 <= totalDataCount * 8) {
          buffer.put(0, 4);
        }
  
        // padding
        while (buffer.getLengthInBits() % 8 !== 0) {
          buffer.putBit(false);
        }
  
        // padding
        while (true) {
  
          if (buffer.getLengthInBits() >= totalDataCount * 8) {
            break;
          }
          buffer.put(PAD0, 8);
  
          if (buffer.getLengthInBits() >= totalDataCount * 8) {
            break;
          }
          buffer.put(PAD1, 8);
        }
  
        return createBytes(buffer, rsBlocks);
      };
  
      _this.addData = function(data, mode) {
  
        mode = mode || 'Byte';
  
        var newData = null;
  
        switch(mode) {
        case 'Numeric' :
          newData = qrNumber(data);
          break;
        case 'Alphanumeric' :
          newData = qrAlphaNum(data);
          break;
        case 'Byte' :
          newData = qr8BitByte(data);
          break;
        case 'Kanji' :
          newData = qrKanji(data);
          break;
        default :
          throw new Error('mode:' + mode);
        }
  
        _dataList.push(newData);
        _dataCache = null;
      };
  
      _this.isDark = function(row, col) {
        if (row < 0 || _moduleCount <= row || col < 0 || _moduleCount <= col) {
          throw new Error(row + ',' + col);
        }
        return _modules[row][col] !== mt_empty;
      };
  
      _this.getModuleCount = function() {
        return _moduleCount;
      };
  
      _this.make = function() {
        if (_typeNumber < 1) {
          var typeNumber = 1;
  
          for (; typeNumber < 40; typeNumber++) {
            var rsBlocks = QRRSBlock.getRSBlocks(typeNumber, _errorCorrectionLevel);
            var buffer = qrBitBuffer();
  
            for (var i = 0; i < _dataList.length; i++) {
              var data = _dataList[i];
              buffer.put(data.getMode(), 4);
              buffer.put(data.getLength(), QRUtil.getLengthInBits(data.getMode(), typeNumber) );
              data.write(buffer);
            }
  
            var totalDataCount = 0;
            for (var i2 = 0; i2 < rsBlocks.length; i2++) {
              totalDataCount += rsBlocks[i2].dataCount;
            }
  
            if (buffer.getLengthInBits() <= totalDataCount * 8) {
              break;
            }
          }
  
          _typeNumber = typeNumber;
        }
  
        makeImpl(false, getBestMaskPattern() );
      };
  
      _this.createTableTag = function(cellSize, margin) {
  
        cellSize = cellSize || 2;
        margin = (typeof margin == 'undefined')? cellSize * 4 : margin;
  
        var qrHtml = '';
  
        qrHtml += '<table style="';
        qrHtml += ' border-width: 0px; border-style: none;';
        qrHtml += ' border-collapse: collapse;';
        qrHtml += ' padding: 0px; margin: ' + margin + 'px;';
        qrHtml += '">';
        qrHtml += '<tbody>';
  
        for (var r = 0; r < _this.getModuleCount(); r += 1) {
  
          qrHtml += '<tr>';
  
          for (var c = 0; c < _this.getModuleCount(); c += 1) {
            qrHtml += '<td style="';
            qrHtml += ' border-width: 0px; border-style: none;';
            qrHtml += ' border-collapse: collapse;';
            qrHtml += ' padding: 0px; margin: 0px;';
            qrHtml += ' width: ' + cellSize + 'px;';
            qrHtml += ' height: ' + cellSize + 'px;';
            qrHtml += ' background-color: ';
            qrHtml += _this.isDark(r, c)? '#000000' : '#ffffff';
            qrHtml += ';';
            qrHtml += '"/>';
          }
  
          qrHtml += '</tr>';
        }
  
        qrHtml += '</tbody>';
        qrHtml += '</table>';
  
        return qrHtml;
      };

      _this.createSvgTag = function(cellSize, margin, alt, title, fillColor) {
  
        var opts = {};
        if (typeof arguments[0] == 'object') {
          // Called by options.
          opts = arguments[0];
          // overwrite cellSize and margin.
          cellSize = opts.cellSize;
          margin = opts.margin;
          alt = opts.alt;
          title = opts.title;
          fillColor = opts.fillColor;
        }
  
        cellSize = cellSize || 2;
        margin = (typeof margin == 'undefined')? cellSize * 4 : margin;
  
        // Compose alt property surrogate
        alt = (typeof alt === 'string') ? {text: alt} : alt || {};
        alt.text = alt.text || null;
        alt.id = (alt.text) ? alt.id || 'qrcode-description' : null;
  
        // Compose title property surrogate
        title = (typeof title === 'string') ? {text: title} : title || {};
        title.text = title.text || null;
        title.id = (title.text) ? title.id || 'qrcode-title' : null;
  
        var size = _this.getModuleCount() * cellSize + margin * 2;
        var c, mc, r, mr, qrSvg='', rect;
  
        rect = 'l' + cellSize + ',0 0,' + cellSize +
          ' -' + cellSize + ',0 0,-' + cellSize + 'z ';
  
        qrSvg += '<svg version="1.1" xmlns="http://www.w3.org/2000/svg"';
        qrSvg += !opts.scalable ? ' width="' + size + 'px" height="' + size + 'px"' : '';
        qrSvg += ' viewBox="0 0 ' + size + ' ' + size + '" ';
        qrSvg += ' preserveAspectRatio="xMinYMin meet"';
        qrSvg += (title.text || alt.text) ? ' role="img" aria-labelledby="' +
            escapeXml([title.id, alt.id].join(' ').trim() ) + '"' : '';
        qrSvg += '>';
        qrSvg += (title.text) ? '<title id="' + escapeXml(title.id) + '">' +
            escapeXml(title.text) + '</title>' : '';
        qrSvg += (alt.text) ? '<description id="' + escapeXml(alt.id) + '">' +
            escapeXml(alt.text) + '</description>' : '';
        qrSvg += '<rect width="100%" height="100%" fill="white" cx="0" cy="0"/>';
        qrSvg += '<path d="';

        // gap calculation start
        var uncuttableAreaSize = 9 * cellSize; // how many rows/cols can't be cut out from each side. derived from the position of adjust pattern
        var gapSizeInParts = 0.35;
        var savedAreaSizeInParts = (1 - gapSizeInParts) / 2;

        var gapX0 = Math.max(size * savedAreaSizeInParts, uncuttableAreaSize + margin);
        var gapX1 = Math.min(size * (1 - savedAreaSizeInParts), size - uncuttableAreaSize - margin);
        var gapY0 = Math.max(size * savedAreaSizeInParts, uncuttableAreaSize + margin);
        var gapY1 = Math.min(size * (1 - savedAreaSizeInParts), size - uncuttableAreaSize - margin);
        // gap calculation end

        for (r = 0; r < _this.getModuleCount(); r += 1) {
          mr = r * cellSize + margin;
          for (c = 0; c < _this.getModuleCount(); c += 1) {
            if (_modules[r][c] === mt_data_true || _modules[r][c] === mt_adjuster) {
              mc = c*cellSize+margin;

              // gap handling start
              var cellX0 = mc
              var cellX1 = mc + cellSize
              var cellY0 = mr
              var cellY1 = mr + cellSize
              if (
                  (
                      (cellX0 > gapX0 && cellX0 < gapX1)
                      || (cellX1 > gapX0 && cellX1 < gapX1)
                  )
                  && (
                      (cellY0 > gapY0 && cellY0 < gapY1)
                      || (cellY1 > gapY0 && cellY1 < gapY1)
                  )
              ) {
                continue;
              }
              // gap handling end


              qrSvg += 'M' + mc + ',' + mr + rect;
            }
          }
        }
        qrSvg += '" stroke="transparent" fill="' + (fillColor ? fillColor : 'black') + '"/>';

        var drawProbe = function(x, y, fillColor, cellSize) {
          return '<path d="M ' + x + ' ' + (y + cellSize)   // left upper corner
              + ' Q ' + x + ' ' + y + ' ' + (x + cellSize) + ' ' + y
              + ' H ' + (x + (cellSize * 6))
              + ' Q ' + (x + (cellSize * 7)) + ' ' + y + ' ' + (x + (cellSize * 7)) + ' ' + (y + cellSize)
              + ' V ' + (y + (cellSize * 6))
              + ' Q ' + (x + (cellSize * 7)) + ' ' + (y + (cellSize * 7)) + ' ' + (x + (cellSize * 6)) + ' ' + (y + (cellSize * 7))
              + ' H ' + (x + cellSize)
              + ' Q ' + x + ' ' + (y + cellSize * 7) + ' ' + x + ' ' + (y + cellSize * 6)
              + ' V ' + x + ' ' + (y + cellSize)
              + ' Z"'
              + ' fill="' + fillColor + '"></path>'
              + '<rect x="' + (x + cellSize) + '"'
              + ' y="' + (y + cellSize) + '"'
              + ' height="' + (cellSize * 5) + '"'
              + ' width="' + (cellSize * 5) + '"'
              + ' fill="white"'
              + '></rect>'
              + '<rect x="' + (x + (2 * cellSize)) + '"'
              + ' y="' + (y + (2 * cellSize)) + '"'
              + ' height="' + (cellSize * 3) + '"'
              + ' width="' + (cellSize * 3) + '"'
              + ' fill="' + fillColor + '"'
              + '></rect>';
        }

        qrSvg += drawProbe(margin, margin, (fillColor ? fillColor : 'black'), cellSize)
        qrSvg += drawProbe(size - margin - (cellSize * 7), margin, (fillColor ? fillColor : 'black'), cellSize)
        qrSvg += drawProbe(margin, size - margin - (cellSize * 7), (fillColor ? fillColor : 'black'), cellSize)

        // logo inserting start
        var logoWidth = (gapY1 - gapY0) * 0.8;
        var logoHeight = (gapX1 - gapX0) * 0.8;
        var logoX = gapX0 + ((gapX1 - gapX0) * 0.1);
        var logoY = gapY0 + ((gapY1 - gapY0) * 0.1);
        var logoSvg = wafleeLogoSvgText.replace(
            'PLACEHOLDER',
            'width="' + logoWidth + 'px" height="' + logoHeight + 'px" x="' + logoX + 'px" y="' + logoY + 'px"');
        qrSvg += logoSvg;
        // logo inserting end

        qrSvg += '</svg>';
  
        return qrSvg;
      };
  
      _this.createDataURL = function(cellSize, margin) {
  
        cellSize = cellSize || 2;
        margin = (typeof margin == 'undefined')? cellSize * 4 : margin;
  
        var size = _this.getModuleCount() * cellSize + margin * 2;
        var min = margin;
        var max = size - margin;
  
        return createDataURL(size, size, function(x, y) {
          if (min <= x && x < max && min <= y && y < max) {
            var c = Math.floor( (x - min) / cellSize);
            var r = Math.floor( (y - min) / cellSize);
            return _this.isDark(r, c)? 0 : 1;
          } else {
            return 1;
          }
        } );
      };
  
      _this.createImgTag = function(cellSize, margin, alt) {
  
        cellSize = cellSize || 2;
        margin = (typeof margin == 'undefined')? cellSize * 4 : margin;
  
        var size = _this.getModuleCount() * cellSize + margin * 2;
  
        var img = '';
        img += '<img';
        img += '\u0020src="';
        img += _this.createDataURL(cellSize, margin);
        img += '"';
        img += '\u0020width="';
        img += size;
        img += '"';
        img += '\u0020height="';
        img += size;
        img += '"';
        if (alt) {
          img += '\u0020alt="';
          img += escapeXml(alt);
          img += '"';
        }
        img += '/>';
  
        return img;
      };
  
      var escapeXml = function(s) {
        var escaped = '';
        for (var i = 0; i < s.length; i += 1) {
          var c = s.charAt(i);
          switch(c) {
          case '<': escaped += '&lt;'; break;
          case '>': escaped += '&gt;'; break;
          case '&': escaped += '&amp;'; break;
          case '"': escaped += '&quot;'; break;
          default : escaped += c; break;
          }
        }
        return escaped;
      };
  
      var _createHalfASCII = function(margin) {
        var cellSize = 1;
        margin = (typeof margin === 'undefined') ? cellSize * 2 : margin;
  
        var size = _this.getModuleCount() * cellSize + margin * 2;
        var min = margin;
        var max = size - margin;
  
        var y, x, r1, r2, p;
  
        var blocks = {
          '██': '█',
          '█ ': '▀',
          ' █': '▄',
          '  ': ' '
        };
  
        var blocksLastLineNoMargin = {
          '██': '▀',
          '█ ': '▀',
          ' █': ' ',
          '  ': ' '
        };
  
        var ascii = '';
        for (y = 0; y < size; y += 2) {
          r1 = Math.floor((y - min) / cellSize);
          r2 = Math.floor((y + 1 - min) / cellSize);
          for (x = 0; x < size; x += 1) {
            p = '█';
  
            if (min <= x && x < max && min <= y && y < max && _this.isDark(r1, Math.floor((x - min) / cellSize))) {
              p = ' ';
            }
  
            if (min <= x && x < max && min <= y+1 && y+1 < max && _this.isDark(r2, Math.floor((x - min) / cellSize))) {
              p += ' ';
            }
            else {
              p += '█';
            }
  
            // Output 2 characters per pixel, to create full square. 1 character per pixels gives only half width of square.
            ascii += (margin < 1 && y+1 >= max) ? blocksLastLineNoMargin[p] : blocks[p];
          }
  
          ascii += '\n';
        }
  
        if (size % 2 && margin > 0) {
          return ascii.substring(0, ascii.length - size - 1) + Array(size+1).join('▀');
        }
  
        return ascii.substring(0, ascii.length-1);
      };
  
      _this.createASCII = function(cellSize, margin) {
        cellSize = cellSize || 1;
  
        if (cellSize < 2) {
          return _createHalfASCII(margin);
        }
  
        cellSize -= 1;
        margin = (typeof margin == 'undefined')? cellSize * 2 : margin;
  
        var size = _this.getModuleCount() * cellSize + margin * 2;
        var min = margin;
        var max = size - margin;
  
        var y, x, r, p;
  
        var white = Array(cellSize+1).join('██');
        var black = Array(cellSize+1).join('  ');
  
        var ascii = '';
        var line = '';
        for (y = 0; y < size; y += 1) {
          r = Math.floor( (y - min) / cellSize);
          line = '';
          for (x = 0; x < size; x += 1) {
            p = 1;
  
            if (min <= x && x < max && min <= y && y < max && _this.isDark(r, Math.floor((x - min) / cellSize))) {
              p = 0;
            }
  
            // Output 2 characters per pixel, to create full square. 1 character per pixels gives only half width of square.
            line += p ? white : black;
          }
  
          for (r = 0; r < cellSize; r += 1) {
            ascii += line + '\n';
          }
        }
  
        return ascii.substring(0, ascii.length-1);
      };
  
      _this.renderTo2dContext = function(context, cellSize) {
        cellSize = cellSize || 2;
        var length = _this.getModuleCount();
        for (var row = 0; row < length; row++) {
          for (var col = 0; col < length; col++) {
            context.fillStyle = _this.isDark(row, col) ? 'black' : 'white';
            context.fillRect(row * cellSize, col * cellSize, cellSize, cellSize);
          }
        }
      }
  
      return _this;
    };
  
    //---------------------------------------------------------------------
    // qrcode.stringToBytes
    //---------------------------------------------------------------------
  
    qrcode.stringToBytesFuncs = {
      'default' : function(s) {
        var bytes = [];
        for (var i = 0; i < s.length; i += 1) {
          var c = s.charCodeAt(i);
          bytes.push(c & 0xff);
        }
        return bytes;
      }
    };
  
    qrcode.stringToBytes = qrcode.stringToBytesFuncs['default'];
  
    //---------------------------------------------------------------------
    // qrcode.createStringToBytes
    //---------------------------------------------------------------------
  
    /**
     * @param unicodeData base64 string of byte array.
     * [16bit Unicode],[16bit Bytes], ...
     * @param numChars
     */
    qrcode.createStringToBytes = function(unicodeData, numChars) {
  
      // create conversion map.
  
      var unicodeMap = function() {
  
        var bin = base64DecodeInputStream(unicodeData);
        var read = function() {
          var b = bin.read();
          if (b === -1) throw new Error('eof');
          return b;
        };
  
        var count = 0;
        var unicodeMap = {};
        while (true) {
          var b0 = bin.read();
          if (b0 === -1) break;
          var b1 = read();
          var b2 = read();
          var b3 = read();
          var k = String.fromCharCode( (b0 << 8) | b1);
          var v = (b2 << 8) | b3;
          unicodeMap[k] = v;
          count += 1;
        }
        if (count !== numChars) {
          throw new Error(count + ' !== ' + numChars);
        }
  
        return unicodeMap;
      }();
  
      var unknownChar = '?'.charCodeAt(0);
  
      return function(s) {
        var bytes = [];
        for (var i = 0; i < s.length; i += 1) {
          var c = s.charCodeAt(i);
          if (c < 128) {
            bytes.push(c);
          } else {
            var b = unicodeMap[s.charAt(i)];
            if (typeof b == 'number') {
              if ( (b & 0xff) === b) {
                // 1byte
                bytes.push(b);
              } else {
                // 2bytes
                bytes.push(b >>> 8);
                bytes.push(b & 0xff);
              }
            } else {
              bytes.push(unknownChar);
            }
          }
        }
        return bytes;
      };
    };
  
    //---------------------------------------------------------------------
    // QRMode
    //---------------------------------------------------------------------
  
    var QRMode = {
      MODE_NUMBER :    1 << 0,
      MODE_ALPHA_NUM : 1 << 1,
      MODE_8BIT_BYTE : 1 << 2,
      MODE_KANJI :     1 << 3
    };
  
    //---------------------------------------------------------------------
    // QRErrorCorrectionLevel
    //---------------------------------------------------------------------
  
    var QRErrorCorrectionLevel = {
      L : 1,
      M : 0,
      Q : 3,
      H : 2
    };
  
    //---------------------------------------------------------------------
    // QRMaskPattern
    //---------------------------------------------------------------------
  
    var QRMaskPattern = {
      PATTERN000 : 0,
      PATTERN001 : 1,
      PATTERN010 : 2,
      PATTERN011 : 3,
      PATTERN100 : 4,
      PATTERN101 : 5,
      PATTERN110 : 6,
      PATTERN111 : 7
    };
  
    //---------------------------------------------------------------------
    // QRUtil
    //---------------------------------------------------------------------
  
    var QRUtil = function() {
  
      var PATTERN_POSITION_TABLE = [
        [],
        [6, 18],
        [6, 22],
        [6, 26],
        [6, 30],
        [6, 34],
        [6, 22, 38],
        [6, 24, 42],
        [6, 26, 46],
        [6, 28, 50],
        [6, 30, 54],
        [6, 32, 58],
        [6, 34, 62],
        [6, 26, 46, 66],
        [6, 26, 48, 70],
        [6, 26, 50, 74],
        [6, 30, 54, 78],
        [6, 30, 56, 82],
        [6, 30, 58, 86],
        [6, 34, 62, 90],
        [6, 28, 50, 72, 94],
        [6, 26, 50, 74, 98],
        [6, 30, 54, 78, 102],
        [6, 28, 54, 80, 106],
        [6, 32, 58, 84, 110],
        [6, 30, 58, 86, 114],
        [6, 34, 62, 90, 118],
        [6, 26, 50, 74, 98, 122],
        [6, 30, 54, 78, 102, 126],
        [6, 26, 52, 78, 104, 130],
        [6, 30, 56, 82, 108, 134],
        [6, 34, 60, 86, 112, 138],
        [6, 30, 58, 86, 114, 142],
        [6, 34, 62, 90, 118, 146],
        [6, 30, 54, 78, 102, 126, 150],
        [6, 24, 50, 76, 102, 128, 154],
        [6, 28, 54, 80, 106, 132, 158],
        [6, 32, 58, 84, 110, 136, 162],
        [6, 26, 54, 82, 110, 138, 166],
        [6, 30, 58, 86, 114, 142, 170]
      ];
      var G15 = (1 << 10) | (1 << 8) | (1 << 5) | (1 << 4) | (1 << 2) | (1 << 1) | (1 << 0);
      var G18 = (1 << 12) | (1 << 11) | (1 << 10) | (1 << 9) | (1 << 8) | (1 << 5) | (1 << 2) | (1 << 0);
      var G15_MASK = (1 << 14) | (1 << 12) | (1 << 10) | (1 << 4) | (1 << 1);
  
      var _this = {};
  
      var getBCHDigit = function(data) {
        var digit = 0;
        while (data !== 0) {
          digit += 1;
          data >>>= 1;
        }
        return digit;
      };
  
      _this.getBCHTypeInfo = function(data) {
        var d = data << 10;
        while (getBCHDigit(d) - getBCHDigit(G15) >= 0) {
          d ^= (G15 << (getBCHDigit(d) - getBCHDigit(G15) ) );
        }
        return ( (data << 10) | d) ^ G15_MASK;
      };
  
      _this.getBCHTypeNumber = function(data) {
        var d = data << 12;
        while (getBCHDigit(d) - getBCHDigit(G18) >= 0) {
          d ^= (G18 << (getBCHDigit(d) - getBCHDigit(G18) ) );
        }
        return (data << 12) | d;
      };
  
      _this.getPatternPosition = function(typeNumber) {
        return PATTERN_POSITION_TABLE[typeNumber - 1];
      };
  
      _this.getMaskFunction = function(maskPattern) {
  
        switch (maskPattern) {
  
        case QRMaskPattern.PATTERN000 :
          return function(i, j) { return (i + j) % 2 === 0; };
        case QRMaskPattern.PATTERN001 :
          return function(i, j) { return i % 2 === 0; };
        case QRMaskPattern.PATTERN010 :
          return function(i, j) { return j % 3 === 0; };
        case QRMaskPattern.PATTERN011 :
          return function(i, j) { return (i + j) % 3 === 0; };
        case QRMaskPattern.PATTERN100 :
          return function(i, j) { return (Math.floor(i / 2) + Math.floor(j / 3) ) % 2 === 0; };
        case QRMaskPattern.PATTERN101 :
          return function(i, j) { return (i * j) % 2 + (i * j) % 3 === 0; };
        case QRMaskPattern.PATTERN110 :
          return function(i, j) { return ( (i * j) % 2 + (i * j) % 3) % 2 === 0; };
        case QRMaskPattern.PATTERN111 :
          return function(i, j) { return ( (i * j) % 3 + (i + j) % 2) % 2 === 0; };
  
        default :
          throw new Error('bad maskPattern:' + maskPattern);
        }
      };
  
      _this.getErrorCorrectPolynomial = function(errorCorrectLength) {
        var a = qrPolynomial([1], 0);
        for (var i = 0; i < errorCorrectLength; i += 1) {
          a = a.multiply(qrPolynomial([1, QRMath.gexp(i)], 0) );
        }
        return a;
      };
  
      _this.getLengthInBits = function(mode, type) {
  
        if (1 <= type && type < 10) {
  
          // 1 - 9
  
          switch(mode) {
          case QRMode.MODE_NUMBER    : return 10;
          case QRMode.MODE_ALPHA_NUM : return 9;
          case QRMode.MODE_8BIT_BYTE : return 8;
          case QRMode.MODE_KANJI     : return 8;
          default :
            throw new Error('mode:' + mode);
          }
  
        } else if (type < 27) {
  
          // 10 - 26
  
          switch(mode) {
          case QRMode.MODE_NUMBER    : return 12;
          case QRMode.MODE_ALPHA_NUM : return 11;
          case QRMode.MODE_8BIT_BYTE : return 16;
          case QRMode.MODE_KANJI     : return 10;
          default :
            throw new Error('mode:' + mode);
          }
  
        } else if (type < 41) {
  
          // 27 - 40
  
          switch(mode) {
          case QRMode.MODE_NUMBER    : return 14;
          case QRMode.MODE_ALPHA_NUM : return 13;
          case QRMode.MODE_8BIT_BYTE : return 16;
          case QRMode.MODE_KANJI     : return 12;
          default :
            throw new Error('mode:' + mode);
          }
  
        } else {
          throw new Error('type:' + type);
        }
      };
  
      _this.getLostPoint = function(qrcode) {
  
        var moduleCount = qrcode.getModuleCount();
  
        var lostPoint = 0;
  
        // LEVEL1
  
        for (var row = 0; row < moduleCount; row += 1) {
          for (var col = 0; col < moduleCount; col += 1) {
  
            var sameCount = 0;
            var dark = qrcode.isDark(row, col);
  
            for (var r = -1; r <= 1; r += 1) {
  
              if (row + r < 0 || moduleCount <= row + r) {
                continue;
              }
  
              for (var c = -1; c <= 1; c += 1) {
  
                if (col + c < 0 || moduleCount <= col + c) {
                  continue;
                }
  
                if (r === 0 && c === 0) {
                  continue;
                }
  
                if (dark === qrcode.isDark(row + r, col + c) ) {
                  sameCount += 1;
                }
              }
            }
  
            if (sameCount > 5) {
              lostPoint += (3 + sameCount - 5);
            }
          }
        };
  
        // LEVEL2
  
        for (var row2 = 0; row2 < moduleCount - 1; row2 += 1) {
          for (var col2 = 0; col2 < moduleCount - 1; col2 += 1) {
            var count = 0;
            if (qrcode.isDark(row2, col2) ) count += 1;
            if (qrcode.isDark(row2 + 1, col2) ) count += 1;
            if (qrcode.isDark(row2, col2 + 1) ) count += 1;
            if (qrcode.isDark(row2 + 1, col2 + 1) ) count += 1;
            if (count === 0 || count === 4) {
              lostPoint += 3;
            }
          }
        }
  
        // LEVEL3
  
        for (var row3 = 0; row3 < moduleCount; row3 += 1) {
          for (var col3 = 0; col3 < moduleCount - 6; col3 += 1) {
            if (qrcode.isDark(row3, col3)
                && !qrcode.isDark(row3, col3 + 1)
                &&  qrcode.isDark(row3, col3 + 2)
                &&  qrcode.isDark(row3, col3 + 3)
                &&  qrcode.isDark(row3, col3 + 4)
                && !qrcode.isDark(row3, col3 + 5)
                &&  qrcode.isDark(row3, col3 + 6) ) {
              lostPoint += 40;
            }
          }
        }
  
        for (var col4 = 0; col4 < moduleCount; col4 += 1) {
          for (var row4 = 0; row4 < moduleCount - 6; row4 += 1) {
            if (qrcode.isDark(row4, col4)
                && !qrcode.isDark(row4 + 1, col4)
                &&  qrcode.isDark(row4 + 2, col4)
                &&  qrcode.isDark(row4 + 3, col4)
                &&  qrcode.isDark(row4 + 4, col4)
                && !qrcode.isDark(row4 + 5, col4)
                &&  qrcode.isDark(row4 + 6, col4) ) {
              lostPoint += 40;
            }
          }
        }
  
        // LEVEL4
  
        var darkCount = 0;
  
        for (var col5 = 0; col5 < moduleCount; col5 += 1) {
          for (var row5 = 0; row5 < moduleCount; row5 += 1) {
            if (qrcode.isDark(row5, col5) ) {
              darkCount += 1;
            }
          }
        }
  
        var ratio = Math.abs(100 * darkCount / moduleCount / moduleCount - 50) / 5;
        lostPoint += ratio * 10;
  
        return lostPoint;
      };
  
      return _this;
    }();
  
    //---------------------------------------------------------------------
    // QRMath
    //---------------------------------------------------------------------
  
    var QRMath = function() {
  
      var EXP_TABLE = new Array(256);
      var LOG_TABLE = new Array(256);
  
      // initialize tables
      for (var i = 0; i < 8; i += 1) {
        EXP_TABLE[i] = 1 << i;
      }
      for (var i2 = 8; i2 < 256; i2 += 1) {
        EXP_TABLE[i2] = EXP_TABLE[i2 - 4]
          ^ EXP_TABLE[i2 - 5]
          ^ EXP_TABLE[i2 - 6]
          ^ EXP_TABLE[i2 - 8];
      }
      for (var i3 = 0; i3 < 255; i3 += 1) {
        LOG_TABLE[EXP_TABLE[i3] ] = i3;
      }
  
      var _this = {};
  
      _this.glog = function(n) {
  
        if (n < 1) {
          throw new Error('glog(' + n + ')');
        }
  
        return LOG_TABLE[n];
      };
  
      _this.gexp = function(n) {
  
        while (n < 0) {
          n += 255;
        }
  
        while (n >= 256) {
          n -= 255;
        }
  
        return EXP_TABLE[n];
      };
  
      return _this;
    }();
  
    //---------------------------------------------------------------------
    // qrPolynomial
    //---------------------------------------------------------------------
  
    function qrPolynomial(num, shift) {
  
      if (typeof num.length == 'undefined') {
        throw new Error(num.length + '/' + shift);
      }
  
      var _num = function() {
        var offset = 0;
        while (offset < num.length && num[offset] === 0) {
          offset += 1;
        }
        var _num = new Array(num.length - offset + shift);
        for (var i = 0; i < num.length - offset; i += 1) {
          _num[i] = num[i + offset];
        }
        return _num;
      }();
  
      var _this = {};
  
      _this.getAt = function(index) {
        return _num[index];
      };
  
      _this.getLength = function() {
        return _num.length;
      };
  
      _this.multiply = function(e) {
  
        var num = new Array(_this.getLength() + e.getLength() - 1);
  
        for (var i = 0; i < _this.getLength(); i += 1) {
          for (var j = 0; j < e.getLength(); j += 1) {
            num[i + j] ^= QRMath.gexp(QRMath.glog(_this.getAt(i) ) + QRMath.glog(e.getAt(j) ) );
          }
        }
  
        return qrPolynomial(num, 0);
      };
  
      _this.mod = function(e) {
  
        if (_this.getLength() - e.getLength() < 0) {
          return _this;
        }
  
        var ratio = QRMath.glog(_this.getAt(0) ) - QRMath.glog(e.getAt(0) );
  
        var num = new Array(_this.getLength() );
        for (var i = 0; i < _this.getLength(); i += 1) {
          num[i] = _this.getAt(i);
        }
  
        for (var i2 = 0; i2 < e.getLength(); i2 += 1) {
          num[i2] ^= QRMath.gexp(QRMath.glog(e.getAt(i2) ) + ratio);
        }
  
        // recursive call
        return qrPolynomial(num, 0).mod(e);
      };
  
      return _this;
    };
  
    //---------------------------------------------------------------------
    // QRRSBlock
    //---------------------------------------------------------------------
  
    var QRRSBlock = function() {
  
      var RS_BLOCK_TABLE = [
  
        // L
        // M
        // Q
        // H
  
        // 1
        [1, 26, 19],
        [1, 26, 16],
        [1, 26, 13],
        [1, 26, 9],
  
        // 2
        [1, 44, 34],
        [1, 44, 28],
        [1, 44, 22],
        [1, 44, 16],
  
        // 3
        [1, 70, 55],
        [1, 70, 44],
        [2, 35, 17],
        [2, 35, 13],
  
        // 4
        [1, 100, 80],
        [2, 50, 32],
        [2, 50, 24],
        [4, 25, 9],
  
        // 5
        [1, 134, 108],
        [2, 67, 43],
        [2, 33, 15, 2, 34, 16],
        [2, 33, 11, 2, 34, 12],
  
        // 6
        [2, 86, 68],
        [4, 43, 27],
        [4, 43, 19],
        [4, 43, 15],
  
        // 7
        [2, 98, 78],
        [4, 49, 31],
        [2, 32, 14, 4, 33, 15],
        [4, 39, 13, 1, 40, 14],
  
        // 8
        [2, 121, 97],
        [2, 60, 38, 2, 61, 39],
        [4, 40, 18, 2, 41, 19],
        [4, 40, 14, 2, 41, 15],
  
        // 9
        [2, 146, 116],
        [3, 58, 36, 2, 59, 37],
        [4, 36, 16, 4, 37, 17],
        [4, 36, 12, 4, 37, 13],
  
        // 10
        [2, 86, 68, 2, 87, 69],
        [4, 69, 43, 1, 70, 44],
        [6, 43, 19, 2, 44, 20],
        [6, 43, 15, 2, 44, 16],
  
        // 11
        [4, 101, 81],
        [1, 80, 50, 4, 81, 51],
        [4, 50, 22, 4, 51, 23],
        [3, 36, 12, 8, 37, 13],
  
        // 12
        [2, 116, 92, 2, 117, 93],
        [6, 58, 36, 2, 59, 37],
        [4, 46, 20, 6, 47, 21],
        [7, 42, 14, 4, 43, 15],
  
        // 13
        [4, 133, 107],
        [8, 59, 37, 1, 60, 38],
        [8, 44, 20, 4, 45, 21],
        [12, 33, 11, 4, 34, 12],
  
        // 14
        [3, 145, 115, 1, 146, 116],
        [4, 64, 40, 5, 65, 41],
        [11, 36, 16, 5, 37, 17],
        [11, 36, 12, 5, 37, 13],
  
        // 15
        [5, 109, 87, 1, 110, 88],
        [5, 65, 41, 5, 66, 42],
        [5, 54, 24, 7, 55, 25],
        [11, 36, 12, 7, 37, 13],
  
        // 16
        [5, 122, 98, 1, 123, 99],
        [7, 73, 45, 3, 74, 46],
        [15, 43, 19, 2, 44, 20],
        [3, 45, 15, 13, 46, 16],
  
        // 17
        [1, 135, 107, 5, 136, 108],
        [10, 74, 46, 1, 75, 47],
        [1, 50, 22, 15, 51, 23],
        [2, 42, 14, 17, 43, 15],
  
        // 18
        [5, 150, 120, 1, 151, 121],
        [9, 69, 43, 4, 70, 44],
        [17, 50, 22, 1, 51, 23],
        [2, 42, 14, 19, 43, 15],
  
        // 19
        [3, 141, 113, 4, 142, 114],
        [3, 70, 44, 11, 71, 45],
        [17, 47, 21, 4, 48, 22],
        [9, 39, 13, 16, 40, 14],
  
        // 20
        [3, 135, 107, 5, 136, 108],
        [3, 67, 41, 13, 68, 42],
        [15, 54, 24, 5, 55, 25],
        [15, 43, 15, 10, 44, 16],
  
        // 21
        [4, 144, 116, 4, 145, 117],
        [17, 68, 42],
        [17, 50, 22, 6, 51, 23],
        [19, 46, 16, 6, 47, 17],
  
        // 22
        [2, 139, 111, 7, 140, 112],
        [17, 74, 46],
        [7, 54, 24, 16, 55, 25],
        [34, 37, 13],
  
        // 23
        [4, 151, 121, 5, 152, 122],
        [4, 75, 47, 14, 76, 48],
        [11, 54, 24, 14, 55, 25],
        [16, 45, 15, 14, 46, 16],
  
        // 24
        [6, 147, 117, 4, 148, 118],
        [6, 73, 45, 14, 74, 46],
        [11, 54, 24, 16, 55, 25],
        [30, 46, 16, 2, 47, 17],
  
        // 25
        [8, 132, 106, 4, 133, 107],
        [8, 75, 47, 13, 76, 48],
        [7, 54, 24, 22, 55, 25],
        [22, 45, 15, 13, 46, 16],
  
        // 26
        [10, 142, 114, 2, 143, 115],
        [19, 74, 46, 4, 75, 47],
        [28, 50, 22, 6, 51, 23],
        [33, 46, 16, 4, 47, 17],
  
        // 27
        [8, 152, 122, 4, 153, 123],
        [22, 73, 45, 3, 74, 46],
        [8, 53, 23, 26, 54, 24],
        [12, 45, 15, 28, 46, 16],
  
        // 28
        [3, 147, 117, 10, 148, 118],
        [3, 73, 45, 23, 74, 46],
        [4, 54, 24, 31, 55, 25],
        [11, 45, 15, 31, 46, 16],
  
        // 29
        [7, 146, 116, 7, 147, 117],
        [21, 73, 45, 7, 74, 46],
        [1, 53, 23, 37, 54, 24],
        [19, 45, 15, 26, 46, 16],
  
        // 30
        [5, 145, 115, 10, 146, 116],
        [19, 75, 47, 10, 76, 48],
        [15, 54, 24, 25, 55, 25],
        [23, 45, 15, 25, 46, 16],
  
        // 31
        [13, 145, 115, 3, 146, 116],
        [2, 74, 46, 29, 75, 47],
        [42, 54, 24, 1, 55, 25],
        [23, 45, 15, 28, 46, 16],
  
        // 32
        [17, 145, 115],
        [10, 74, 46, 23, 75, 47],
        [10, 54, 24, 35, 55, 25],
        [19, 45, 15, 35, 46, 16],
  
        // 33
        [17, 145, 115, 1, 146, 116],
        [14, 74, 46, 21, 75, 47],
        [29, 54, 24, 19, 55, 25],
        [11, 45, 15, 46, 46, 16],
  
        // 34
        [13, 145, 115, 6, 146, 116],
        [14, 74, 46, 23, 75, 47],
        [44, 54, 24, 7, 55, 25],
        [59, 46, 16, 1, 47, 17],
  
        // 35
        [12, 151, 121, 7, 152, 122],
        [12, 75, 47, 26, 76, 48],
        [39, 54, 24, 14, 55, 25],
        [22, 45, 15, 41, 46, 16],
  
        // 36
        [6, 151, 121, 14, 152, 122],
        [6, 75, 47, 34, 76, 48],
        [46, 54, 24, 10, 55, 25],
        [2, 45, 15, 64, 46, 16],
  
        // 37
        [17, 152, 122, 4, 153, 123],
        [29, 74, 46, 14, 75, 47],
        [49, 54, 24, 10, 55, 25],
        [24, 45, 15, 46, 46, 16],
  
        // 38
        [4, 152, 122, 18, 153, 123],
        [13, 74, 46, 32, 75, 47],
        [48, 54, 24, 14, 55, 25],
        [42, 45, 15, 32, 46, 16],
  
        // 39
        [20, 147, 117, 4, 148, 118],
        [40, 75, 47, 7, 76, 48],
        [43, 54, 24, 22, 55, 25],
        [10, 45, 15, 67, 46, 16],
  
        // 40
        [19, 148, 118, 6, 149, 119],
        [18, 75, 47, 31, 76, 48],
        [34, 54, 24, 34, 55, 25],
        [20, 45, 15, 61, 46, 16]
      ];
  
      var qrRSBlock = function(totalCount, dataCount) {
        var _this = {};
        _this.totalCount = totalCount;
        _this.dataCount = dataCount;
        return _this;
      };
  
      var _this = {};
  
      var getRsBlockTable = function(typeNumber, errorCorrectionLevel) {
  
        switch(errorCorrectionLevel) {
        case QRErrorCorrectionLevel.L :
          return RS_BLOCK_TABLE[(typeNumber - 1) * 4 + 0];
        case QRErrorCorrectionLevel.M :
          return RS_BLOCK_TABLE[(typeNumber - 1) * 4 + 1];
        case QRErrorCorrectionLevel.Q :
          return RS_BLOCK_TABLE[(typeNumber - 1) * 4 + 2];
        case QRErrorCorrectionLevel.H :
          return RS_BLOCK_TABLE[(typeNumber - 1) * 4 + 3];
        default :
          return undefined;
        }
      };
  
      _this.getRSBlocks = function(typeNumber, errorCorrectionLevel) {
  
        var rsBlock = getRsBlockTable(typeNumber, errorCorrectionLevel);
  
        if (typeof rsBlock == 'undefined') {
          throw new Error('bad rs block @ typeNumber:' + typeNumber +
              '/errorCorrectionLevel:' + errorCorrectionLevel);
        }
  
        var length = rsBlock.length / 3;
  
        var list = [];
  
        for (var i = 0; i < length; i += 1) {
  
          var count = rsBlock[i * 3 + 0];
          var totalCount = rsBlock[i * 3 + 1];
          var dataCount = rsBlock[i * 3 + 2];
  
          for (var j = 0; j < count; j += 1) {
            list.push(qrRSBlock(totalCount, dataCount) );
          }
        }
  
        return list;
      };
  
      return _this;
    }();
  
    //---------------------------------------------------------------------
    // qrBitBuffer
    //---------------------------------------------------------------------
  
    var qrBitBuffer = function() {
  
      var _buffer = [];
      var _length = 0;
  
      var _this = {};
  
      _this.getBuffer = function() {
        return _buffer;
      };
  
      _this.getAt = function(index) {
        var bufIndex = Math.floor(index / 8);
        return ( (_buffer[bufIndex] >>> (7 - index % 8) ) & 1) === 1;
      };
  
      _this.put = function(num, length) {
        for (var i = 0; i < length; i += 1) {
          _this.putBit( ( (num >>> (length - i - 1) ) & 1) === 1);
        }
      };
  
      _this.getLengthInBits = function() {
        return _length;
      };
  
      _this.putBit = function(bit) {
  
        var bufIndex = Math.floor(_length / 8);
        if (_buffer.length <= bufIndex) {
          _buffer.push(0);
        }
  
        if (bit) {
          _buffer[bufIndex] |= (0x80 >>> (_length % 8) );
        }
  
        _length += 1;
      };
  
      return _this;
    };
  
    //---------------------------------------------------------------------
    // qrNumber
    //---------------------------------------------------------------------
  
    var qrNumber = function(data) {
  
      var _mode = QRMode.MODE_NUMBER;
      var _data = data;
  
      var _this = {};
  
      _this.getMode = function() {
        return _mode;
      };
  
      _this.getLength = function(buffer) {
        return _data.length;
      };
  
      _this.write = function(buffer) {
  
        var data = _data;
  
        var i = 0;
  
        while (i + 2 < data.length) {
          buffer.put(strToNum(data.substring(i, i + 3) ), 10);
          i += 3;
        }
  
        if (i < data.length) {
          if (data.length - i === 1) {
            buffer.put(strToNum(data.substring(i, i + 1) ), 4);
          } else if (data.length - i === 2) {
            buffer.put(strToNum(data.substring(i, i + 2) ), 7);
          }
        }
      };
  
      var strToNum = function(s) {
        var num = 0;
        for (var i = 0; i < s.length; i += 1) {
          num = num * 10 + chatToNum(s.charAt(i) );
        }
        return num;
      };
  
      var chatToNum = function(c) {
        if ('0' <= c && c <= '9') {
          return c.charCodeAt(0) - '0'.charCodeAt(0);
        }
        throw new Error('illegal char :' + c);
      };
  
      return _this;
    };
  
    //---------------------------------------------------------------------
    // qrAlphaNum
    //---------------------------------------------------------------------
  
    var qrAlphaNum = function(data) {
  
      var _mode = QRMode.MODE_ALPHA_NUM;
      var _data = data;
  
      var _this = {};
  
      _this.getMode = function() {
        return _mode;
      };
  
      _this.getLength = function(buffer) {
        return _data.length;
      };
  
      _this.write = function(buffer) {
  
        var s = _data;
  
        var i = 0;
  
        while (i + 1 < s.length) {
          buffer.put(
            getCode(s.charAt(i) ) * 45 +
            getCode(s.charAt(i + 1) ), 11);
          i += 2;
        }
  
        if (i < s.length) {
          buffer.put(getCode(s.charAt(i) ), 6);
        }
      };
  
      var getCode = function(c) {
  
        if ('0' <= c && c <= '9') {
          return c.charCodeAt(0) - '0'.charCodeAt(0);
        } else if ('A' <= c && c <= 'Z') {
          return c.charCodeAt(0) - 'A'.charCodeAt(0) + 10;
        } else {
          switch (c) {
          case ' ' : return 36;
          case '$' : return 37;
          case '%' : return 38;
          case '*' : return 39;
          case '+' : return 40;
          case '-' : return 41;
          case '.' : return 42;
          case '/' : return 43;
          case ':' : return 44;
          default :
            throw new Error('illegal char :' + c);
          }
        }
      };
  
      return _this;
    };
  
    //---------------------------------------------------------------------
    // qr8BitByte
    //---------------------------------------------------------------------
  
    var qr8BitByte = function(data) {
  
      var _mode = QRMode.MODE_8BIT_BYTE;
      var _bytes = qrcode.stringToBytesFuncs['UTF-8'](data);
  
      var _this = {};
  
      _this.getMode = function() {
        return _mode;
      };
  
      _this.getLength = function(buffer) {
        return _bytes.length;
      };
  
      _this.write = function(buffer) {
        for (var i = 0; i < _bytes.length; i += 1) {
          buffer.put(_bytes[i], 8);
        }
      };
  
      return _this;
    };
  
    //---------------------------------------------------------------------
    // qrKanji
    //---------------------------------------------------------------------
  
    var qrKanji = function(data) {
  
      var _mode = QRMode.MODE_KANJI;
  
      var stringToBytes = qrcode.stringToBytesFuncs['SJIS'];
      if (!stringToBytes) {
        throw new Error('sjis not supported.');
      }
      
      
      // self test for sjis support.
      var test = stringToBytes('\u53cb');
      if (test.length !== 2 || ( (test[0] << 8) | test[1]) !== 0x9746) {
        throw new Error('sjis not supported.');
      }
  
      var _bytes = stringToBytes(data);
  
      var _this = {};
  
      _this.getMode = function() {
        return _mode;
      };
  
      _this.getLength = function(buffer) {
        return ~~(_bytes.length / 2);
      };
  
      _this.write = function(buffer) {
  
        var data = _bytes;
  
        var i = 0;
  
        while (i + 1 < data.length) {
  
          var c = ( (0xff & data[i]) << 8) | (0xff & data[i + 1]);
  
          if (0x8140 <= c && c <= 0x9FFC) {
            c -= 0x8140;
          } else if (0xE040 <= c && c <= 0xEBBF) {
            c -= 0xC140;
          } else {
            throw new Error('illegal char at ' + (i + 1) + '/' + c);
          }
  
          c = ( (c >>> 8) & 0xff) * 0xC0 + (c & 0xff);
  
          buffer.put(c, 13);
  
          i += 2;
        }
  
        if (i < data.length) {
          throw new Error('illegal char at ' + (i + 1));
        }
      };
  
      return _this;
    };
  
    //=====================================================================
    // GIF Support etc.
    //
  
    //---------------------------------------------------------------------
    // byteArrayOutputStream
    //---------------------------------------------------------------------
  
    var byteArrayOutputStream = function() {
  
      var _bytes = [];
  
      var _this = {};
  
      _this.writeByte = function(b) {
        _bytes.push(b & 0xff);
      };
  
      _this.writeShort = function(i) {
        _this.writeByte(i);
        _this.writeByte(i >>> 8);
      };
  
      _this.writeBytes = function(b, off, len) {
        off = off || 0;
        len = len || b.length;
        for (var i = 0; i < len; i += 1) {
          _this.writeByte(b[i + off]);
        }
      };
  
      _this.writeString = function(s) {
        for (var i = 0; i < s.length; i += 1) {
          _this.writeByte(s.charCodeAt(i) );
        }
      };
  
      _this.toByteArray = function() {
        return _bytes;
      };
  
      _this.toString = function() {
        var s = '';
        s += '[';
        for (var i = 0; i < _bytes.length; i += 1) {
          if (i > 0) {
            s += ',';
          }
          s += _bytes[i];
        }
        s += ']';
        return s;
      };
  
      return _this;
    };
  
    //---------------------------------------------------------------------
    // base64EncodeOutputStream
    //---------------------------------------------------------------------
  
    var base64EncodeOutputStream = function() {
  
      var _buffer = 0;
      var _buflen = 0;
      var _length = 0;
      var _base64 = '';
  
      var _this = {};
  
      var writeEncoded = function(b) {
        _base64 += String.fromCharCode(encode(b & 0x3f) );
      };
  
      var encode = function(n) {
        if (n < 0) {
          // error.
        } else if (n < 26) {
          return 0x41 + n;
        } else if (n < 52) {
          return 0x61 + (n - 26);
        } else if (n < 62) {
          return 0x30 + (n - 52);
        } else if (n === 62) {
          return 0x2b;
        } else if (n === 63) {
          return 0x2f;
        }
        throw new Error('n:' + n);
      };
  
      _this.writeByte = function(n) {
  
        _buffer = (_buffer << 8) | (n & 0xff);
        _buflen += 8;
        _length += 1;
  
        while (_buflen >= 6) {
          writeEncoded(_buffer >>> (_buflen - 6) );
          _buflen -= 6;
        }
      };
  
      _this.flush = function() {
  
        if (_buflen > 0) {
          writeEncoded(_buffer << (6 - _buflen) );
          _buffer = 0;
          _buflen = 0;
        }
  
        if (_length % 3 !== 0) {
          // padding
          var padlen = 3 - _length % 3;
          for (var i = 0; i < padlen; i += 1) {
            _base64 += '=';
          }
        }
      };
  
      _this.toString = function() {
        return _base64;
      };
  
      return _this;
    };
  
    //---------------------------------------------------------------------
    // base64DecodeInputStream
    //---------------------------------------------------------------------
  
    var base64DecodeInputStream = function(str) {
  
      var _str = str;
      var _pos = 0;
      var _buffer = 0;
      var _buflen = 0;
  
      var _this = {};
  
      _this.read = function() {
  
        while (_buflen < 8) {
  
          if (_pos >= _str.length) {
            if (_buflen === 0) {
              return -1;
            }
            throw new Error('unexpected end of file./' + _buflen);
          }
  
          var c = _str.charAt(_pos);
          _pos += 1;
  
          if (c === '=') {
            _buflen = 0;
            return -1;
          } else if (c.match(/^\s$/) ) {
            // ignore if whitespace.
            continue;
          }
  
          _buffer = (_buffer << 6) | decode(c.charCodeAt(0) );
          _buflen += 6;
        }
  
        var n = (_buffer >>> (_buflen - 8) ) & 0xff;
        _buflen -= 8;
        return n;
      };
  
      var decode = function(c) {
        if (0x41 <= c && c <= 0x5a) {
          return c - 0x41;
        } else if (0x61 <= c && c <= 0x7a) {
          return c - 0x61 + 26;
        } else if (0x30 <= c && c <= 0x39) {
          return c - 0x30 + 52;
        } else if (c === 0x2b) {
          return 62;
        } else if (c === 0x2f) {
          return 63;
        } else {
          throw new Error('c:' + c);
        }
      };
  
      return _this;
    };
  
    //---------------------------------------------------------------------
    // gifImage (B/W)
    //---------------------------------------------------------------------
  
    var gifImage = function(width, height) {
  
      var _width = width;
      var _height = height;
      var _data = new Array(width * height);
  
      var _this = {};
  
      _this.setPixel = function(x, y, pixel) {
        _data[y * _width + x] = pixel;
      };
  
      _this.write = function(out) {
  
        //---------------------------------
        // GIF Signature
  
        out.writeString('GIF87a');
  
        //---------------------------------
        // Screen Descriptor
  
        out.writeShort(_width);
        out.writeShort(_height);
  
        out.writeByte(0x80); // 2bit
        out.writeByte(0);
        out.writeByte(0);
  
        //---------------------------------
        // Global Color Map
  
        // black
        out.writeByte(0x00);
        out.writeByte(0x00);
        out.writeByte(0x00);
  
        // white
        out.writeByte(0xff);
        out.writeByte(0xff);
        out.writeByte(0xff);
  
        //---------------------------------
        // Image Descriptor
  
        out.writeString(',');
        out.writeShort(0);
        out.writeShort(0);
        out.writeShort(_width);
        out.writeShort(_height);
        out.writeByte(0);
  
        //---------------------------------
        // Local Color Map
  
        //---------------------------------
        // Raster Data
  
        var lzwMinCodeSize = 2;
        var raster = getLZWRaster(lzwMinCodeSize);
  
        out.writeByte(lzwMinCodeSize);
  
        var offset = 0;
  
        while (raster.length - offset > 255) {
          out.writeByte(255);
          out.writeBytes(raster, offset, 255);
          offset += 255;
        }
  
        out.writeByte(raster.length - offset);
        out.writeBytes(raster, offset, raster.length - offset);
        out.writeByte(0x00);
  
        //---------------------------------
        // GIF Terminator
        out.writeString(';');
      };
  
      var bitOutputStream = function(out) {
  
        var _out = out;
        var _bitLength = 0;
        var _bitBuffer = 0;
  
        var _this = {};
  
        _this.write = function(data, length) {
  
          if ( (data >>> length) !== 0) {
            throw new Error('length over');
          }
  
          while (_bitLength + length >= 8) {
            _out.writeByte(0xff & ( (data << _bitLength) | _bitBuffer) );
            length -= (8 - _bitLength);
            data >>>= (8 - _bitLength);
            _bitBuffer = 0;
            _bitLength = 0;
          }
  
          _bitBuffer = (data << _bitLength) | _bitBuffer;
          _bitLength = _bitLength + length;
        };
  
        _this.flush = function() {
          if (_bitLength > 0) {
            _out.writeByte(_bitBuffer);
          }
        };
  
        return _this;
      };
  
      var getLZWRaster = function(lzwMinCodeSize) {
  
        var clearCode = 1 << lzwMinCodeSize;
        var endCode = (1 << lzwMinCodeSize) + 1;
        var bitLength = lzwMinCodeSize + 1;
  
        // Setup LZWTable
        var table = lzwTable();
  
        for (var i = 0; i < clearCode; i += 1) {
          table.add(String.fromCharCode(i) );
        }
        table.add(String.fromCharCode(clearCode) );
        table.add(String.fromCharCode(endCode) );
  
        var byteOut = byteArrayOutputStream();
        var bitOut = bitOutputStream(byteOut);
  
        // clear code
        bitOut.write(clearCode, bitLength);
  
        var dataIndex = 0;
  
        var s = String.fromCharCode(_data[dataIndex]);
        dataIndex += 1;
  
        while (dataIndex < _data.length) {
  
          var c = String.fromCharCode(_data[dataIndex]);
          dataIndex += 1;
  
          if (table.contains(s + c) ) {
  
            s = s + c;
  
          } else {
  
            bitOut.write(table.indexOf(s), bitLength);
  
            if (table.size() < 0xfff) {
  
              if (table.size() === (1 << bitLength) ) {
                bitLength += 1;
              }
  
              table.add(s + c);
            }
  
            s = c;
          }
        }
  
        bitOut.write(table.indexOf(s), bitLength);
  
        // end code
        bitOut.write(endCode, bitLength);
  
        bitOut.flush();
  
        return byteOut.toByteArray();
      };
  
      var lzwTable = function() {
  
        var _map = {};
        var _size = 0;
  
        var _this = {};
  
        _this.add = function(key) {
          if (_this.contains(key) ) {
            throw new Error('dup key:' + key);
          }
          _map[key] = _size;
          _size += 1;
        };
  
        _this.size = function() {
          return _size;
        };
  
        _this.indexOf = function(key) {
          return _map[key];
        };
  
        _this.contains = function(key) {
          return typeof _map[key] !== 'undefined';
        };
  
        return _this;
      };
  
      return _this;
    };
  
    var createDataURL = function(width, height, getPixel) {
      var gif = gifImage(width, height);
      for (var y = 0; y < height; y += 1) {
        for (var x = 0; x < width; x += 1) {
          gif.setPixel(x, y, getPixel(x, y) );
        }
      }
  
      var b = byteArrayOutputStream();
      gif.write(b);
  
      var base64 = base64EncodeOutputStream();
      var bytes = b.toByteArray();
      for (var i = 0; i < bytes.length; i += 1) {
        base64.writeByte(bytes[i]);
      }
      base64.flush();
  
      return 'data:image/gif;base64,' + base64;
    };
  
    //---------------------------------------------------------------------
    // returns qrcode function.
  
    return qrcode;
  }();
  
  // multibyte support
  
  
  qrcode.stringToBytesFuncs['UTF-8'] = function(s) {
      // http://stackoverflow.com/questions/18729405/how-to-convert-utf8-string-to-byte-array
      function toUTF8Array(str) {
        var utf8 = [];
        for (var i=0; i < str.length; i++) {
          var charcode = str.charCodeAt(i);
          if (charcode < 0x80) utf8.push(charcode);
          else if (charcode < 0x800) {
            utf8.push(0xc0 | (charcode >> 6),
                0x80 | (charcode & 0x3f));
          }
          else if (charcode < 0xd800 || charcode >= 0xe000) {
            utf8.push(0xe0 | (charcode >> 12),
                0x80 | ((charcode>>6) & 0x3f),
                0x80 | (charcode & 0x3f));
          }
          // surrogate pair
          else {
            i++;
            // UTF-16 encodes 0x10000-0x10FFFF by
            // subtracting 0x10000 and splitting the
            // 20 bits of 0x0-0xFFFFF into two halves
            charcode = 0x10000 + (((charcode & 0x3ff)<<10)
              | (str.charCodeAt(i) & 0x3ff));
            utf8.push(0xf0 | (charcode >>18),
                0x80 | ((charcode>>12) & 0x3f),
                0x80 | ((charcode>>6) & 0x3f),
                0x80 | (charcode & 0x3f));
          }
        }
        return utf8;
      }
      return toUTF8Array(s);
  };
  
